import React from "react";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import Spinner from "../../common/components/spinner/spinner";
import Button from '@material-ui/core/Button';
import ClientDataComponent from './offerSteps/clientDataComponent';
import PlannerHouseComponent from './offerSteps/plannerHouseComponent';
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actionTypes';
import Translate from "../../common/functions/translate";
import { OfferStepModel } from '../../models/offer/offerStepModel';
import { ClientDataModel } from '../../models/offerSteps/clientDataModel';
import { OfferSteps, OfferStatus, CategoryType, Units, StepperPosition } from '../../common/enums';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faSave, faCalculator, faCloudUploadAlt, faPen, faClock } from '@fortawesome/free-solid-svg-icons';
import { DropdownModel } from "../../models/dropdownModel";
import GasInstallation from './offerSteps/gasInstallationComponent';
import Snackbar from "../../common/components/snackbar/snackbar";
import ClientsService from "../../services/clientsService";
import { ClientModel } from "../../models/client/clientModel";
import { ClientLocationModel } from "../../models/client/clientLocationModel";
import HeathInstallationComponent from "./offerSteps/heatInstallationComponent";
import { TwoDimPlanModel } from "../../models/offerSteps/twoDimPlanModel";
import StepButton from '@material-ui/core/StepButton'
import { GasInstallationModel } from "../../models/offerSteps/gasInstallationModel";
import { HeathInstallModel } from "../../models/offerSteps/heathInstallModel";
import { ProductModel } from "../../models/product/productModel";
import LocalClientsService from "../../services/localDataServices/localClientsService";
import { ProductRelationFilterModel } from "../../models/product/productRelationFilterModel";
import ProductService from '../../services/productService';
import LocalOffersService from "../../services/localDataServices/localOffersService";
import LocalProductsService from "../../services/localDataServices/localProductsService";
import GenerateOfferComponent from "./offerSteps/generateOfferComponent";
import { ProductLiteModel } from "../../models/product/productLiteModel";
import { newPlannerProject2Layers } from '../../common/constants';
import { ClientSearchModel } from "../../models/client/clientSearchModel";
import GeneratePDFService from '../../services/generatePdfFromBase';
import AuthService from '../../services/authService';
import { FileModel } from '../../models/fileModel';
import SynchronizationService from "../../services/synchronizationService";
import LocalCategoryService from '../../services/localDataServices/localCategoryService';
import { PipeInfoModel } from '../../models/product/pipeInfoModel';
import { PipeModel } from '../../models/product/pipeModel';
import convert from 'convert-units'
import { FittingsModel } from "../../models/offerSteps/fittingsModel";
import { IProduct, ICategory } from "../../common/appDatabase";
import GenerateXlxsService from "../../services/generateXlsxService";
import { ProductToProductModel } from "../../models/product/productToProductModel";
import { FittingComboModel } from '../../models/product/fittingComboModel';
import { GeometryUtils } from 'react-planner/es/utils/export';
import { FittingProductModel } from '../../models/product/fittingProductModel';
import AlertDialog from '../../common/components/alertDialog/alertDialog';
import { EmailDataModel } from '../../models/emailDataModel';
import EmailService from "../../services/emailService";
import ConfirmDialog from '../../common/components/confirmDialog/confirmDialog';
import ChangeStatusDialog from './changeStatusDialog';
import { OfferStatusHistoryModel } from "../../models/offer/offerStatusHistoryModel";
import { UserModel } from '../../models/user';

interface IProps {
    history: any;
    isPlannerVisible: boolean;
    setPlanner: any;
    match: any,
}


interface IState {
    isLoading: boolean;
    newOffer: OfferStepModel;
    steps: Array<number>;
    selectedClientId: number;
    clientAddresses: Array<DropdownModel>;
    selectedAddress: number;
    allClients: Array<ClientModel>;
    allLocations: Array<ClientLocationModel>;
    searchedProductsDropDown: Array<DropdownModel>;
    currentSelection: DropdownModel | null;
    searchTerm: string;
    searchedProducts: Array<ProductModel>;
    validations: Array<string>;
    selectedClient: ClientSearchModel;
    copiedLayer: boolean;
    spinnerText: string;
    readOnly: boolean;
    isVisiblePipeCalculationDialog: boolean,
    pipeCalculationResult: string,
    isVisibleFittingsCalculationDialog: boolean,
    fittingsCalculationResult: string,
    isVisibleSendEmailConfirmDialog: boolean,
    changeStatusDialogIsOpen: boolean,
}


class AddEditOfferComponent extends React.Component<IProps, IState>{
    clientService = new ClientsService();
    productService = new ProductService();
    localClientService = new LocalClientsService();
    localOffersService = new LocalOffersService();
    localProductsService = new LocalProductsService();
    authService = new AuthService();
    synchronizationService = new SynchronizationService();
    localCategoryService = new LocalCategoryService();
    generatePDFService = new GeneratePDFService();
    generateXlxsService = new GenerateXlxsService();
    emailService = new EmailService();
    snackbar: any;

    constructor(props: IProps) {
        super(props);
        this.state = {
            isLoading: false,
            newOffer: new OfferStepModel(),
            steps: new Array<number>(0),
            selectedClientId: 0,
            clientAddresses: new Array<DropdownModel>(0),
            selectedAddress: 0,
            allClients: new Array<ClientModel>(0),
            allLocations: new Array<ClientLocationModel>(0),
            searchTerm: '',
            searchedProducts: new Array<ProductModel>(),
            searchedProductsDropDown: new Array<DropdownModel>(),
            currentSelection: null,
            validations: new Array<string>(0),
            selectedClient: new ClientSearchModel(),
            copiedLayer: false,
            spinnerText: '',
            readOnly: false,
            isVisiblePipeCalculationDialog: false,
            pipeCalculationResult: '',
            isVisibleFittingsCalculationDialog: false,
            fittingsCalculationResult: '',
            isVisibleSendEmailConfirmDialog: false,
            changeStatusDialogIsOpen: false,
        };
    }

    componentDidMount() {
        let copiedLayer = HelperFunctions.getURLParameter('copiedLayer');
        if (copiedLayer && copiedLayer === 'true')
            this.setState({ copiedLayer: true });

        this.initData();
    }

    initData() {
        let offerId = this.props.match.params.OfferId;
        let offer = { ...this.state.newOffer };
        if (offerId && offerId > 0) {
            offer.activeStep = OfferSteps.ClientData;
            offer.completed = new Array<number>(0);
            this.setState({
                newOffer: offer,
                isLoading: true
            });

            this.localOffersService.getOffer(offerId).then(
                (offer: any) => {
                    this.localClientService.getLocations(offer.clientData.clientId).then(
                        (locations: any) => {
                            let steps: Array<number> = [];

                            if (!offer.equipmentOnly) {
                                steps = [OfferSteps.ClientData, OfferSteps.TwoDPlan, OfferSteps.GasInstallation, OfferSteps.GenerateOffer];
                                if (offer.heathInstallCheck)
                                    steps = [OfferSteps.ClientData, OfferSteps.TwoDPlan, OfferSteps.GasInstallation, OfferSteps.HeatingInstallation, OfferSteps.GenerateOffer];
                            } else {
                                steps = [OfferSteps.ClientData, OfferSteps.GasInstallation, OfferSteps.GenerateOffer];
                                if (offer.heathInstallCheck)
                                    steps = [OfferSteps.ClientData, OfferSteps.GasInstallation, OfferSteps.HeatingInstallation, OfferSteps.GenerateOffer];
                            }

                            if (!offer.adminNotes)
                                offer.adminNotes = Translate('AdminNote');
                            if (!offer.gasInstallation)
                                offer.gasInstallation = new GasInstallationModel();
                            if (!offer.gasInstallation.additionalProducts)
                                offer.gasInstallation.additionalProducts = new Array<ProductModel>();
                            if (!offer.gasInstallation.products)
                                offer.gasInstallation.products = new Array<ProductModel>();
                            if (!offer.gasInstallation.activeTab)
                                offer.gasInstallation.activeTab = 0;

                            if (!offer.heathInstall)
                                offer.heathInstall = new HeathInstallModel();
                            if (!offer.heathInstall.additionalProducts)
                                offer.heathInstall.additionalProducts = new Array<ProductModel>();
                            if (!offer.heathInstall.products)
                                offer.heathInstall.products = new Array<ProductModel>();
                            if (!offer.heathInstall.activeTab)
                                offer.heathInstall.activeTab = 0;

                            let newDropDown: Array<DropdownModel> = new Array<DropdownModel>(0);
                            newDropDown.push({ value: 0, label: Translate('New') });

                            if (locations) {
                                locations.forEach(location => {
                                    newDropDown.push({ value: location.id, label: location.address });
                                });
                            }

                            this.setState({
                                isLoading: false,
                                newOffer: offer,
                                steps,
                                clientAddresses: newDropDown,
                                selectedClientId: offer.clientData.clientId,
                                selectedAddress: offer.clientData.locationId,
                                allLocations: locations,
                                readOnly: offer.offerStatusId !== OfferStatus.NewOffer && offer.offerStatusId !== OfferStatus.Expired
                            });
                        }
                    ).catch(error => {
                        this.snackbar.show({ severity: "error", summary: Translate(error) });
                        this.setState({
                            isLoading: false
                        });
                    })
                })
                .catch(error => {
                    this.snackbar.show({ severity: "error", summary: Translate(error) });
                    this.setState({
                        isLoading: false
                    });
                })
        } else {
            offer.offerNumber = this.localOffersService.generateOfferNumber();
            offer.offerDate = HelperFunctions.formatDateAsLongString(new Date());
            offer.activeStep = OfferSteps.ClientData;
            offer.offerStatusId = OfferStatus.NewOffer;
            offer.adminNotes = Translate('AdminNote');
            offer.completed = new Array<number>(0);
            if (!offer.clientData) {
                offer.clientData = new ClientDataModel();
            }

            offer.trader = new UserModel();
            offer.trader.userId = this.authService.getUserId();
            offer.trader.name = this.authService.getUserName();
            offer.trader.phone = this.authService.getUserPhone();
            offer.trader.email = this.authService.getLoginName();

            if (!offer.twoDimPlan) {
                offer.twoDimPlan = new TwoDimPlanModel();
                offer.twoDimPlan.roomHeight = 300;
            }
            if (!offer.gasInstallation) {
                offer.gasInstallation = new GasInstallationModel();
                offer.gasInstallation.additionalProducts = new Array<ProductLiteModel>(0);
                offer.gasInstallation.products = new Array<ProductLiteModel>(0);
                offer.gasInstallation.activeTab = 0;
            }
            if (!offer.heathInstall) {
                offer.heathInstall = new HeathInstallModel();
                offer.heathInstall.additionalProducts = new Array<ProductLiteModel>();
                offer.heathInstall.products = new Array<ProductLiteModel>();
                offer.heathInstall.activeTab = 0;
            }

            let statusHistory = this.createStatusHistory(OfferStatus.NewOffer);

            offer.statusHistory = new Array<OfferStatusHistoryModel>();
            offer.statusHistory.push(statusHistory);

            let steps: Array<number> = [OfferSteps.ClientData, OfferSteps.TwoDPlan, OfferSteps.GasInstallation, OfferSteps.GenerateOffer];
            let newDropDown: Array<DropdownModel> = new Array<DropdownModel>(0);
            newDropDown.push({ value: 0, label: Translate('New') });
            this.setState({ newOffer: offer, steps, clientAddresses: newDropDown });
        }
    }

    handleOfferChange = (key, value) => {
        if (key === 'discount' && value > 100)
            return;

        if ((key === 'discount' || key === 'fixedDiscount') && !value)
            value = 0;

        const offer: OfferStepModel = { ...this.state.newOffer };
        offer[key] = value;
        this.setState({ newOffer: { ...offer } });
    };

    handleHeatSwitchChange = (checked) => {
        let steps = [...this.state.steps]
        let heathSystem = OfferSteps.HeatingInstallation;
        let offer = { ...this.state.newOffer };
        offer.heathInstallCheck = checked;
        let indexOfStep = steps.indexOf(heathSystem);
        if (indexOfStep !== -1) {
            steps.splice(indexOfStep, 1)
        }
        else {
            let gasInstall = steps.indexOf(OfferSteps.GasInstallation);
            steps.splice(gasInstall + 1, 0, heathSystem)
        }

        if (checked === false && offer.planner) {
            offer.planner.layers["layer-3"] = newPlannerProject2Layers.layers["layer-3"];
        }

        this.setState({ newOffer: offer, steps });
    }

    handleWorkSwitchChange = (checked) => {
        let offer = { ...this.state.newOffer };
        offer.workAndMaterials = checked;
        this.setState({ newOffer: offer });
    }

    handleGasInstallWorkChange = (checked) => {
        let offer = { ...this.state.newOffer };
        offer.gasInstallation.gasInstallWork = checked;
        offer.gasInstallation.additionalProducts = new Array<ProductLiteModel>(0);
        this.setState({ newOffer: offer });
    }

    handleEquipmentOnlySwitchChange = (checked) => {
        let offer = { ...this.state.newOffer };
        let steps = [...this.state.steps];

        if (checked) {
            let twoDimPlanIndex = steps.findIndex(c => c === OfferSteps.TwoDPlan);

            if (twoDimPlanIndex !== -1) {
                steps.splice(twoDimPlanIndex, 1);
            }
        } else {
            let clientDataIndex = steps.findIndex(c => c === OfferSteps.ClientData);

            if (clientDataIndex !== -1) {
                steps.splice(clientDataIndex + 1, 0, OfferSteps.TwoDPlan)
            }
        }


        offer.equipmentOnly = checked;
        this.setState({ newOffer: offer, steps });
    }

    handleHeathInstallWorkChange = (checked) => {
        let offer = { ...this.state.newOffer };
        offer.heathInstall.heathInstallWork = checked;
        offer.heathInstall.additionalProducts = new Array<ProductLiteModel>(0);
        this.setState({ newOffer: offer });
    }

    handleChangeClient = (key, value) => {
        let offer = { ...this.state.newOffer };
        let client = { ...offer.clientData };
        client[key] = value;
        offer.clientData = client;
        this.setState({ newOffer: offer });
    }

    handleEditClient = (client: ClientDataModel) => {
        let offer = { ...this.state.newOffer };
        offer.clientData = client

        this.setState({ newOffer: offer });
    }

    handleTwoDimChange = (key, value) => {
        let offer = { ...this.state.newOffer };
        let twoDim = { ...offer.twoDimPlan };
        twoDim[key] = value;
        offer.twoDimPlan = twoDim;
        this.setState({ newOffer: offer });
    }

    visibleToFalsePlanner = (object) => {
        for (let prop in object) {
            object[prop].selected = false;
        }
        return object;
    }

    removeSelectedFromLayer = (layer) => {
        for (let prop in layer.selected) {
            layer.selected[prop] = [];
        }
        if (layer.vertices)
            layer.vertices = this.visibleToFalsePlanner(layer.vertices);

        if (layer.lines)
            layer.lines = this.visibleToFalsePlanner(layer.lines);

        if (layer.holes)
            layer.holes = this.visibleToFalsePlanner(layer.holes);

        if (layer.areas)
            layer.areas = this.visibleToFalsePlanner(layer.areas);

        if (layer.items)
            layer.items = this.visibleToFalsePlanner(layer.items);

        if (layer.pipes)
            layer.pipes = this.visibleToFalsePlanner(layer.pipes);

        return layer;
    }

    createFile = (installationPdf, pdfFile, title) => {
        let newFile = installationPdf
        if (!newFile)
            newFile = new FileModel();

        newFile.fileContent = pdfFile;
        newFile.fileSizeInBytes = Math.round(pdfFile.length * 3 / 4);
        newFile.fileName = title;
        newFile.updatedOn = HelperFunctions.fomatDateTimeAsString(new Date());
        return newFile
    }

    getPipeInfo = (pipes, unit, holes) => {
        let pipeInfo = new PipeInfoModel();
        pipeInfo.pipes = new Array<PipeModel>(0);
        pipeInfo.lengthSum = 0;
        for (let pipe in pipes) {
            let addPipe = new PipeModel();
            addPipe.plannerName = pipe;
            addPipe.altitude = pipes[pipe].properties.altitude ?
                convert(pipes[pipe].properties.altitude.length).from(unit).to('cm') : 0;
            addPipe.diameter = pipes[pipe].properties.diameter ?
                convert(pipes[pipe].properties.diameter.length).from(unit).to('cm') : 0;
            addPipe.pipeLength = pipes[pipe].misc._pipeLength ?
                convert(pipes[pipe].misc._pipeLength).from(unit).to('cm') : 0;
            addPipe.unit = 'cm';
            addPipe.isUnderground = pipes[pipe].properties.is_dashedLine;
            addPipe.productId = pipes[pipe].type && !isNaN(parseInt(pipes[pipe].type)) ? parseInt(pipes[pipe].type) : 0;
            pipeInfo.pipes.push(addPipe);
            pipeInfo.lengthSum += convert(pipes[pipe].misc._pipeLength).from(unit).to('cm');
            pipeInfo.unit = 'cm';
        }

        for (let hole in holes) {
            if (holes[hole].type === '[pipe]vertical-gas-pipe' || holes[hole].type === '[pipe]vertical-water-pipe') {
                let pipe = holes[hole].pipe;
                let addPipe = new PipeModel();
                addPipe.plannerName = hole;
                addPipe.altitude = convert(holes[hole].properties.altitude.length).from(unit).to('cm');
                addPipe.diameter = convert(holes[hole].properties.diameter.length).from(unit).to('cm');
                // addPipe.diameter = pipes[pipe].properties.diameter ?
                //     convert(pipes[pipe].properties.diameter.length).from(unit).to('cm') : 0;
                addPipe.pipeLength = convert(holes[hole].properties.length.length).from(unit).to('cm');
                addPipe.unit = 'cm';
                addPipe.isUnderground = holes[hole].properties.is_dashedLine;
                addPipe.productId = pipes[pipe].type && !isNaN(parseInt(pipes[pipe].type)) ? parseInt(pipes[pipe].type) : 0;

                pipeInfo.pipes.push(addPipe);
            }
        }

        let lengthByUnit = 500; //cm
        pipeInfo.lengthSumRound = pipeInfo.lengthSum + (lengthByUnit - (pipeInfo.lengthSum % lengthByUnit));
        return pipeInfo;
    }

    getFittings = (holes) => {
        let fittings = new FittingsModel();
        for (let fit in fittings) { fittings[fit] = 0; }

        for (let hole in holes) {
            switch (holes[hole].type) {
                case '[pipe]coupling':
                    fittings.couplingCount++;
                    break;
                case '[pipe]magnet-ventil':
                    fittings.magnetVentilsCount++;
                    break;
                case '[pipe]nipel':
                    fittings.nipelCount++;
                    break;
                case '[pipe]transitional-holender':
                    fittings.holenderCount++;
                    break;
                case '[pipe]triple':
                    fittings.tripleCount++;
                    break;
                case '[pipe]ventil':
                    fittings.ventilCount++;
                    break;
                case '[pipe]elbow':
                    fittings.elbowCount++;
                    break;
                default: ;
            }
        }

        return fittings;
    }

    calculatePipes = (offer: OfferStepModel, pipeInfo: PipeInfoModel, dbProducts: Array<IProduct>, products: Array<ProductLiteModel>) => {
        if (offer.gasInstallation) {
            if (pipeInfo && pipeInfo.pipes && pipeInfo.pipes.length > 0) {
                let productsPower = 0;

                products.forEach(product => {
                    let dbProduct = dbProducts.find(p => p.remoteId === product.productId);
                    if (dbProduct) {
                        let biggestPower = dbProduct.power > dbProduct.secondPower ? dbProduct.power : dbProduct.secondPower;
                        productsPower += (biggestPower * product.quantity);
                    }
                });

                let hasPower = productsPower > 0;
                let hasZeroDiameterPipes = false;
                let installationIsCorrect = false;
                let maxDiameter = 0;
                let maxDiameterPipeLenght = 0;

                let pipesByDiameter: Array<any> = new Array<any>(0);
                let maxDiameterPipe: any = null;

                let summary = '';

                if (productsPower > 0) {
                    pipeInfo.pipes.forEach(pipe => {
                        if (!pipe.isUnderground) {
                            if (!pipe.diameter) {
                                hasZeroDiameterPipes = true;
                            }

                            let added = pipesByDiameter.find(p => p.diameter === pipe.diameter);

                            if (added) {
                                added.lenght += pipe.pipeLength;
                            } else {
                                pipesByDiameter.push({ diameter: pipe.diameter, lenght: pipe.pipeLength });
                            }
                        }
                    });

                    if (pipesByDiameter.length > 0) {
                        let pipeWithMaxDiamater = pipesByDiameter.reduce((prev, current) => {
                            return (prev.diameter > current.diameter) ? prev : current
                        });

                        if (pipeWithMaxDiamater) {
                            maxDiameter = pipeWithMaxDiamater.diameter;
                            maxDiameterPipe = pipeWithMaxDiamater;
                        }
                    }

                    if (maxDiameter !== 0 && maxDiameterPipe !== null) {
                        maxDiameterPipeLenght = maxDiameterPipe.lenght / 100;

                        if (productsPower <= 10 && maxDiameter === 18 && maxDiameterPipeLenght <= 60) {
                            installationIsCorrect = true
                        } else if (productsPower <= 25 && maxDiameter === 22 && maxDiameterPipeLenght <= 30) {
                            installationIsCorrect = true
                        } else if (productsPower <= 35 && maxDiameter === 22 && maxDiameterPipeLenght <= 15) {
                            installationIsCorrect = true;
                        } else if (productsPower <= 45 && maxDiameter === 22 && maxDiameterPipeLenght <= 10) {
                            installationIsCorrect = true;
                        } else if (productsPower <= 55 && maxDiameter === 22 && maxDiameterPipeLenght <= 5) {
                            installationIsCorrect = true;
                        } else if (productsPower <= 55 && maxDiameter === 28 && maxDiameterPipeLenght <= 22) {
                            installationIsCorrect = true;
                        } else if (productsPower <= 65 && maxDiameter === 28 && maxDiameterPipeLenght <= 15) {
                            installationIsCorrect = true;
                        }
                    } else {
                        summary = Translate('Cannot get max diamater from pipes');
                    }



                    // if (productsPower <= 10 && pipesLenghtM <= 60) {
                    //     calculatedDiamter = 18;
                    // } else if (productsPower <= 25 && pipesLenghtM <= 30) {
                    //     calculatedDiamter = 22;
                    // } else if (productsPower <= 35 && pipesLenghtM <= 15) {
                    //     calculatedDiamter = 22;
                    // } else if (productsPower <= 45 && pipesLenghtM <= 10) {
                    //     calculatedDiamter = 22;
                    // } else if (productsPower <= 55 && pipesLenghtM <= 5) {
                    //     calculatedDiamter = 22;
                    // } else if (productsPower <= 55 && pipesLenghtM <= 22) {
                    //     calculatedDiamter = 28;
                    // } else if (productsPower <= 65 && pipesLenghtM <= 15) {
                    //     calculatedDiamter = 28;
                    // }
                }

                if (!hasPower) {
                    summary = Translate('Please add products with power');
                }

                if (hasZeroDiameterPipes) {
                    summary = Translate('You have pipes without diameter');
                }

                if (hasPower && !hasZeroDiameterPipes) {
                    if (!installationIsCorrect) {
                        let hasStabilizer = products.find(p => p.article.toLowerCase().includes('стабилизатор'));

                        if (hasStabilizer) {
                            installationIsCorrect = true;
                        }
                    }

                    if (!installationIsCorrect) {
                        summary = `${Translate('Installation is not designed properly')} <br /> 
                        ${Translate('Please add stabilizer or increase pipes diameter')}`;
                    } else {
                        summary = `${Translate('Installation is designed properly')}: <br /><br />`;
                        summary += `<div style="display:flex; justify-content:space-between; width: 300px">
                                        <div>${Translate('ProductsPower')}</div>
                                        <div><strong>${productsPower.toFixed(2)} kW</strong></div>
                                    </div>`;
                        summary += `<div style="display:flex; justify-content:space-between; width: 300px">
                                    <div>${Translate('PipeSumLength')} Ф${maxDiameter}:</div>
                                    <div><strong>${maxDiameterPipeLenght.toFixed(2)} m</strong></div>
                                </div>`;
                        summary += `<div style="display:flex; justify-content:space-between; width: 300px">
                                <div>${Translate('PipesDiameter')}</div>
                                <div><strong>Ф${maxDiameter}</strong></div>
                            </div>`;
                    }
                }

                if (summary) {
                    this.setState({
                        isVisiblePipeCalculationDialog: true,
                        pipeCalculationResult: summary,
                    })
                } else {
                    this.setState({
                        pipeCalculationResult: ''
                    });
                }
            }
        }
    }

    handleCalculatePipe = (categoryPackId) => {
        let planner = JSON.parse(JSON.stringify(localStorage.getItem('react-planner_v0')));
        let offer = { ...this.state.newOffer };
        if (planner) {
            this.localProductsService.getAllProducts().then(
                (res: any) => {
                    let jsonPl = JSON.parse(planner);
                    let layer = 'layer-2';
                    let items = jsonPl.layers[layer].items;
                    let plannerProducts: Array<ProductLiteModel> = this.getItemsFromPlanner(items, res, categoryPackId, OfferSteps.GasInstallation);

                    let pipes = jsonPl.layers[layer].pipes;
                    let holes = jsonPl.layers[layer].holes;
                    let pipeInfo = this.getPipeInfo(pipes, jsonPl.unit, holes);
                    this.calculatePipes(offer, pipeInfo, res, plannerProducts);
                    // offer.gasInstallation.pipeInfo = pipeInfo;
                    // offer.planner = JSON.parse(planner);
                    // this.setState({ newOffer: offer })
                }
            )
                .catch(err => {
                    console.log(err)
                    this.setState({ isLoading: false });
                });
        }
    }

    private getProductCategoryType(productCategoryId: number, dbCategories: Array<ICategory>) {
        let category = dbCategories.find(c => c.remoteId === productCategoryId);

        if (category) {
            if (category.categoryTypeId) {
                return category.categoryTypeId;
            } else {
                let categoryTypeId = 0;
                let currentCategory: ICategory | undefined = category;

                while (categoryTypeId === 0) {
                    // eslint-disable-next-line
                    currentCategory = dbCategories.find(c => c.remoteId === currentCategory!.parentId);

                    if (currentCategory) {
                        categoryTypeId = currentCategory.categoryTypeId;

                        if (!currentCategory.parentId) {
                            break;
                        }
                    } else {
                        break;
                    }
                }

                return categoryTypeId;
            }
        }

        return 0;
    }

    getServicesFromRelatedProducts = (product: ProductLiteModel | null, relatedProducts: Array<ProductToProductModel>, dbProducts: Array<IProduct>, dbCategories: Array<ICategory>): Array<any> => {
        let services = new Array<object>(0);

        if (relatedProducts) {
            relatedProducts.forEach(relatedProduct => {
                let dbProduct = dbProducts.find(p => p.remoteId === relatedProduct.relatedProduct.productId);

                if (dbProduct) {
                    let categoryTypeId = this.getProductCategoryType(dbProduct.categoryId, dbCategories);

                    if (categoryTypeId === CategoryType.Services) {
                        let count = 0;

                        if (product) {
                            count = relatedProduct.count * (product.billQuantity ? product.billQuantity : product.quantity);
                        } else {
                            count = relatedProduct.count;
                        }

                        services.push({ count, product: dbProduct });
                    }

                    if (dbProduct.relatedProducts) {
                        let rpServices = this.getServicesFromRelatedProducts(null, dbProduct.relatedProducts, dbProducts, dbCategories);

                        if (services) {
                            services.push(...rpServices);
                        }
                    }
                }
            })
        }

        // if (dbProduct) {
        //     let categoryTypeId = this.getProductCategoryType(dbProduct.categoryId, dbCategories);

        //     if (categoryTypeId === CategoryType.Services) {
        //         services.push({ count: count, product: dbProduct });
        //     }
        // }

        // if (dbProduct.relatedProducts) {
        //     dbProduct.relatedProducts.forEach(relatedProduct => {
        //         let dbRelatedProduct = dbProducts.find(p => p.remoteId === relatedProduct.relatedProduct.productId);

        //         if (dbRelatedProduct) {
        //             let categoryTypeId = this.getProductCategoryType(dbRelatedProduct.categoryId, dbCategories);

        //             if (categoryTypeId === CategoryType.Services) {
        //                 services.push({ count: relatedProduct.count, product: dbRelatedProduct });
        //             }

        //             if (dbRelatedProduct.relatedProducts) {
        //                 dbRelatedProduct.relatedProducts.forEach(rp => {
        //                     let dbRp = dbProducts.find(p => p.remoteId === rp.relatedProduct.productId);

        //                     if (dbRp) {
        //                         let dbRpServices = this.getServicesFromProduct(dbRp, rp.count, dbProducts, dbCategories);

        //                         if (dbRpServices) {
        //                             services.push(...dbRpServices);
        //                         }
        //                     }
        //                 })
        //             }
        //         }

        //     })
        // }

        return services;
    }

    getServicesFromItemsFromPlanner = (products: Array<ProductLiteModel>, dbProducts: Array<IProduct>, dbCategories: Array<ICategory>): Array<ProductLiteModel> => {
        let services = new Array<ProductLiteModel>(0);

        if (products) {
            products.forEach(product => {
                let dbProduct = dbProducts.find(p => p.remoteId === product.productId);

                if (dbProduct) {
                    let productServices = this.getServicesFromRelatedProducts(product, dbProduct.relatedProducts, dbProducts, dbCategories);

                    if (services) {
                        productServices.forEach(service => {
                            let added = services.find(p => p.productId === service.product.remoteId);

                            if (!added) {
                                let product: ProductLiteModel = new ProductLiteModel();
                                product.article = service.product.article;
                                product.productId = service.product.remoteId;
                                product.price = service.product.price;
                                product.unitId = service.product.unitId;
                                product.articleNumber = service.product.articleNumber;
                                product.quantity = service.count;
                                product.billQuantity = service.count;
                                product.addedFromPlanner = true;
                                product.discount = service.product.discount;
                                product.priceWithoutDiscount = service.product.price;

                                if (service.product.discount > 0) {
                                    product.price = service.product.price - (service.product.price * service.product.discount / 100);
                                }

                                services.push(product);
                            } else {
                                added.quantity += service.count;
                                added.billQuantity += service.count;
                            }

                        })
                    }
                }
            })
        }

        return services;
    }

    handleAddFittingsButton = () => {
        let offer = { ...this.state.newOffer };
        this.localCategoryService.getAllCategories().then(
            (cats: any) => {
                let dbCategories = cats;
                this.localProductsService.getAllProducts().then(
                    (res: any) => {

                        this.addFittings(res, dbCategories, offer);

                        this.handleFittinsResultDialog(offer);

                        this.setState({ newOffer: offer });
                    })
                    .catch(err => {
                        console.log(err)
                        this.setState({ isLoading: false });
                    });
            }).catch(error => {
                this.setState({ isLoading: false });
                this.snackbar.show({ severity: 'error', summary: error })
            });
    }

    handleFittinsResultDialog = (offer: OfferStepModel) => {
        let summary = '';

        if (offer.gasInstallation) {
            if (offer.gasInstallation.fittings && offer.gasInstallation.fittings.autoFittings) {
                if (offer.gasInstallation.fittings.autoFittings.length > 0) {

                    let elbows = offer.gasInstallation.fittings.autoFittings.filter(f => f.article.toLowerCase().includes(Translate('Elbow').toLowerCase()));
                    if (elbows && elbows.length > 0) {
                        let grouped = this.groupFittingsByDiameter(elbows);

                        Object.entries(grouped).map(([key, value]) => { //<strong></strong>
                            let valueArray: any = value;
                            summary += `<div style="display:flex; justify-content:space-between; width: 200px">
                                        <div>${Translate("Elbows")} Ф${key}</div>
                                        <div><strong> ${valueArray.length} ${Translate("pcs")}</strong></div>
                                    </div>`;
                            return 0;
                        });
                    }

                    let triples = offer.gasInstallation.fittings.autoFittings.filter(f => f.article.toLowerCase().includes(Translate('Tee').toLowerCase()));
                    if (triples && triples.length > 0) {
                        let grouped = this.groupFittingsByDiameter(triples);

                        Object.entries(grouped).map(([key, value]) => {
                            let valueArray: any = value;
                            summary += `<div style="display:flex; justify-content:space-between; width: 200px">
                                        <div>${Translate("Tees")} Ф${key}</div>
                                        <div><strong> ${valueArray.length} ${Translate("pcs")}</strong></div>
                                    </div>`;
                            return 0;
                        });
                    }

                    let nipels = offer.gasInstallation.fittings.autoFittings.filter(f => f.article.toLowerCase().includes(Translate('Nipple').toLowerCase()));
                    if (nipels && nipels.length > 0) {
                        let grouped = this.groupFittingsByDiameter(nipels);

                        Object.entries(grouped).map(([key, value]) => {
                            let valueArray: any = value;
                            summary += `<div style="display:flex; justify-content:space-between; width: 200px">
                                        <div>${Translate("Nipples")} Ф${key}</div>
                                        <div><strong> ${valueArray.length} ${Translate("pcs")}</strong></div>
                                    </div>`;
                            return 0;
                        });
                    }
                }
            }
        }

        if (summary) {
            this.setState({
                isVisibleFittingsCalculationDialog: true,
                fittingsCalculationResult: summary,
            })
        } else {
            this.setState({
                fittingsCalculationResult: ''
            });
        }
    }

    groupFittingsByDiameter = (objectsArray) => {
        let grouped = objectsArray.reduce((r, a) => {
            r[a.diameter] = [...r[a.diameter] || [], a];
            return r;
        }, {});

        return grouped;
    }

    addFittings = (dbProducts: Array<IProduct>, dbCategories: Array<ICategory>, offer) => {
        let planner = JSON.parse(JSON.stringify(localStorage.getItem('react-planner_v0')));
        if (planner) {
            let jsonPl = JSON.parse(planner);
            let layer = 'layer-2';
            let pipes = jsonPl.layers[layer].pipes;
            let vertices = jsonPl.layers[layer].vertices;
            let holes = jsonPl.layers[layer].holes;
            //let items = jsonPl.layers[layer].items;
            let allFittings: any = [];

            let pipeFittings = this.addPipeFittings(pipes, vertices, holes);
            allFittings.push(...pipeFittings);

            // Tool fittings removed from fittings calculation logic (10.07.2020)
            // let toolFittings = this.addToolFittings(items, dbProducts, dbCategories);
            // allFittings.push(...toolFittings);

            let fittingsProducts = this.getFittingsProducts(allFittings, dbProducts, dbCategories);
            if (fittingsProducts) {
                if (!offer.gasInstallation.fittings) {
                    offer.gasInstallation.fittings = new FittingsModel();
                    offer.gasInstallation.fittings.autoFittings = new Array<FittingProductModel>(0)
                }

                offer.gasInstallation.fittings.autoFittings = fittingsProducts;
            }

            offer.planner = JSON.parse(planner);
        }
    }

    addToolFittings = (items, dbProducts: Array<IProduct>, dbCategories: Array<ICategory>) => {
        let resultArray: any = [];
        let itemsArray: any = Object.values(items);
        if (itemsArray && itemsArray.length > 0) {
            let gasMeasuringBoards = itemsArray.filter(i => i.type === "gas-measuring-board");
            gasMeasuringBoards.forEach(g => {
                let mainToolFitting = new FittingComboModel();
                mainToolFitting.fittingName = 'Nipple';
                mainToolFitting.fittingType = 'tool';
                mainToolFitting.pipe0diameter = 22;

                resultArray.push(mainToolFitting);
            });

            let toolProducts: any = [];
            for (let item in items) {
                let singleProduct = dbProducts.find(r => r.remoteId === +items[item].type && !items[item].catalogPack.includes('package') &&
                    ((r.article.toLowerCase().includes("котлон") || r.article.toLowerCase().includes("stove")) ||
                        (r.article.toLowerCase().includes("печка") || r.article.toLowerCase().includes("heater") || r.article.toLowerCase().includes("cooker")) ||
                        (r.article.toLowerCase().includes("котел") || r.article.toLowerCase().includes("cauldron") || r.article.toLowerCase().includes("caldron")) ||
                        (r.article.toLowerCase().includes("бойлер") || r.article.toLowerCase().includes("boiler")) ||
                        (r.article.toLowerCase().includes("конвектор") || r.article.toLowerCase().includes("convector"))) &&
                    this.getProductCategoryType(r.categoryId, dbCategories) !== CategoryType.Kits);
                if (singleProduct)
                    toolProducts.push(singleProduct);



                let packet = dbProducts.find(r => r.remoteId === +items[item].type && items[item].catalogPack.includes('package'));
                if (packet) {
                    let packId = +items[item].catalogPack.substring(0, items[item].catalogPack.indexOf('package'));
                    let foundedPack = dbProducts.find(r => r.remoteId === packId);
                    if (foundedPack) {
                        let categoryTypeId = this.getProductCategoryType(foundedPack.categoryId, dbCategories);
                        if (categoryTypeId === CategoryType.Packages) {
                            foundedPack.relatedProducts.forEach(r => {
                                if (((r.relatedProduct.article.toLowerCase().includes("котлон") || r.relatedProduct.article.toLowerCase().includes("stove")) ||
                                    (r.relatedProduct.article.toLowerCase().includes("печка") || r.relatedProduct.article.toLowerCase().includes("heater") || r.relatedProduct.article.toLowerCase().includes("cooker")) ||
                                    (r.relatedProduct.article.toLowerCase().includes("котел") || r.relatedProduct.article.toLowerCase().includes("cauldron") || r.relatedProduct.article.toLowerCase().includes("caldron")) ||
                                    (r.relatedProduct.article.toLowerCase().includes("бойлер") || r.relatedProduct.article.toLowerCase().includes("boiler")) ||
                                    (r.relatedProduct.article.toLowerCase().includes("конвектор") || r.relatedProduct.article.toLowerCase().includes("convector"))) &&
                                    this.getProductCategoryType(r.relatedProduct.categoryId, dbCategories) !== CategoryType.Kits) {
                                    let relatedCategoryTypeId = this.getProductCategoryType(r.relatedProduct.categoryId, dbCategories);
                                    if (relatedCategoryTypeId === CategoryType.Devices)
                                        toolProducts.push(r.relatedProduct);
                                }
                            })
                        }
                    }
                }
            }

            if (toolProducts && toolProducts.length > 0) {
                toolProducts.forEach(p => {
                    let toolFitting = new FittingComboModel();
                    toolFitting.fittingName = 'Nipple';
                    toolFitting.fittingType = 'tool';
                    toolFitting.pipe0diameter = p.article.toLowerCase().includes("котел") ? 22 : 18;

                    resultArray.push(toolFitting);
                })
            }
        }

        return resultArray;
    }

    addPipeFittings = (pipes, vertices, holes) => {
        let pipesArray: any = Object.values(pipes);
        let verticesArray: any = Object.values(vertices);
        let holesArray: any = Object.values(holes);
        let resultArray: any = [];

        let verticlePipes = holesArray.filter(i => i.type === "[pipe]vertical-gas-pipe");
        let configuredVerticlePipes: any = [];

        this.removeZeroLengthPipe(pipesArray, verticesArray);

        let pipePoints: any = [];
        pipesArray.forEach(p => {
            let v0 = verticesArray.find(v => v.id === p.vertices[0]);
            let v1 = verticesArray.find(v => v.id === p.vertices[1]);

            let pointsPair = { pipeID: p.id, v0: v0, v1: v1 };
            pipePoints.push(pointsPair);
        });

        for (let i = 0; i < verticesArray.length; i++) {
            // find is current vertex lying on inner part of other pipe
            let currentVertex = verticesArray[i];
            let vertexOnOtherPipe = pipePoints.filter(p => {
                if (p.pipeID !== currentVertex.pipes[0] && GeometryUtils.isPointOnLineSegment(p.v0.x, p.v0.y, p.v1.x, p.v1.y, currentVertex.x, currentVertex.y)) {
                    let offset = GeometryUtils.pointPositionOnLineSegment(p.v0.x, p.v0.y, p.v1.x, p.v1.y, currentVertex.x, currentVertex.y);
                    if (offset !== 0 && offset !== 1) {
                        return p;
                    }
                }
                return 0;
            });

            // vertex lying on other pipe => should insert triple/tee
            if (vertexOnOtherPipe && vertexOnOtherPipe.length === 1) {
                // if same altitude => insert tee and continue
                if (this.returnPipeAltitude(currentVertex.pipes[0], pipesArray) === this.returnPipeAltitude(vertexOnOtherPipe[0].pipeID, pipesArray)) {
                    let tripleCombo = new FittingComboModel();
                    tripleCombo.fittingName = 'Tee';
                    tripleCombo.fittingType = 'pipe';
                    tripleCombo.pipe0ID = currentVertex.pipes[0];
                    tripleCombo.pipe0VertexID = currentVertex.id;
                    tripleCombo.pipe0diameter = this.returnPipeDiameter(currentVertex.pipes[0], pipesArray);
                    tripleCombo.pipe1ID = vertexOnOtherPipe[0].pipeID;
                    tripleCombo.pipe1VertexID = '';
                    tripleCombo.pipe1diameter = this.returnPipeDiameter(vertexOnOtherPipe[0].pipeID, pipesArray);

                    resultArray.push(tripleCombo);
                    continue;
                }

                let currentVerticlePipe;
                // if not same altitude => check is verticle pipe connecting those pipes
                // case 1 => vert pipe on current vertex
                let vertPipeOnVertex = verticlePipes.find(vp => {
                    if (vp.pipe === currentVertex.pipes[0]) {
                        let pipe = pipesArray.find(p => p.id === currentVertex.pipes[0]);
                        if (pipe) {
                            let v0 = verticesArray.find(v => v.id === pipe.vertices[0]);
                            let v1 = verticesArray.find(v => v.id === pipe.vertices[1]);
                            if (vp.offset === GeometryUtils.pointPositionOnLineSegment(v0.x, v0.y, v1.x, v1.y, currentVertex.x, currentVertex.y)) {
                                return vp;
                            }
                        }
                    }
                    return 0;
                })

                if (vertPipeOnVertex)
                    currentVerticlePipe = vertPipeOnVertex;

                // case 2 => vert pipe on other pipe
                let vertPipeOnPipe = verticlePipes.find(vp => {
                    if (vp.pipe === vertexOnOtherPipe[0].pipeID) {
                        if (GeometryUtils.isCloseEnoughtWithTolerance(vp.offset, GeometryUtils.pointPositionOnLineSegment(vertexOnOtherPipe[0].v0.x, vertexOnOtherPipe[0].v0.y, vertexOnOtherPipe[0].v1.x, vertexOnOtherPipe[0].v1.y, currentVertex.x, currentVertex.y), 0.1)) {
                            return vp
                        }
                    }
                    return 0;
                })

                if (vertPipeOnPipe)
                    currentVerticlePipe = vertPipeOnPipe;

                if (currentVerticlePipe) {
                    let elbowCombo = new FittingComboModel();
                    elbowCombo.fittingName = 'Elbow';
                    elbowCombo.fittingType = 'pipe';
                    elbowCombo.pipe0ID = currentVertex.pipes[0];
                    elbowCombo.pipe0VertexID = currentVertex.id;
                    elbowCombo.pipe0diameter = this.returnPipeDiameter(currentVertex.pipes[0], pipesArray);
                    elbowCombo.pipe1ID = currentVerticlePipe.id;
                    elbowCombo.pipe1VertexID = '';
                    elbowCombo.pipe1diameter = currentVerticlePipe.properties.diameter.length;

                    resultArray.push(elbowCombo); //elbow on vertex pipe

                    let tripleCombo = new FittingComboModel();
                    tripleCombo.fittingName = 'Tee';
                    tripleCombo.fittingType = 'pipe';
                    tripleCombo.pipe0ID = vertexOnOtherPipe[0].pipeID;
                    tripleCombo.pipe0VertexID = '';
                    tripleCombo.pipe0diameter = this.returnPipeDiameter(vertexOnOtherPipe[0].pipeID, pipesArray);
                    tripleCombo.pipe1ID = currentVerticlePipe.id;
                    tripleCombo.pipe1VertexID = '';
                    tripleCombo.pipe1diameter = currentVerticlePipe.properties.diameter.length;

                    resultArray.push(tripleCombo); //triple on other pipe

                    configuredVerticlePipes.push(currentVerticlePipe);

                    continue;
                }
            }

            // vertex to vertex connection
            for (let j = i + 1; j < verticesArray.length; j++) {

                let nextVertex = verticesArray[j];
                if (GeometryUtils.samePoints(currentVertex, nextVertex)) {
                    // if same altitude => insert elbow and continue
                    if (this.returnPipeAltitude(currentVertex.pipes[0], pipesArray) === this.returnPipeAltitude(nextVertex.pipes[0], pipesArray)) {
                        let elbowCombo = new FittingComboModel();
                        elbowCombo.fittingName = 'Elbow';
                        elbowCombo.fittingType = 'pipe';
                        elbowCombo.pipe0ID = currentVertex.pipes[0];
                        elbowCombo.pipe0VertexID = currentVertex.id;
                        elbowCombo.pipe0diameter = this.returnPipeDiameter(currentVertex.pipes[0], pipesArray)
                        elbowCombo.pipe1ID = nextVertex.pipes[0]
                        elbowCombo.pipe1VertexID = nextVertex.id;
                        elbowCombo.pipe1diameter = this.returnPipeDiameter(nextVertex.pipes[0], pipesArray)

                        resultArray.push(elbowCombo);
                        continue;
                    }

                    let currentVerticlePipe;
                    // is vertcle pipe on current vertex
                    let vertPipeOnCurrentVertex = verticlePipes.find(vp => {
                        if (vp.pipe === currentVertex.pipes[0]) {
                            let pipe = pipesArray.find(p => p.id === currentVertex.pipes[0]);
                            if (pipe) {
                                let v0 = verticesArray.find(v => v.id === pipe.vertices[0]);
                                let v1 = verticesArray.find(v => v.id === pipe.vertices[1]);
                                if (GeometryUtils.isCloseEnoughtWithTolerance(vp.offset, GeometryUtils.pointPositionOnLineSegment(v0.x, v0.y, v1.x, v1.y, currentVertex.x, currentVertex.y), 0.1)) {
                                    return vp
                                }
                                // if (vp.offset === GeometryUtils.pointPositionOnLineSegment(v0.x, v0.y, v1.x, v1.y, currentVertex.x, currentVertex.y)) {
                                //     return vp;
                                // }
                            }
                        }
                        return 0;
                    })
                    // is verticle pipe on other vertex
                    let vertPipeOnOtherVertex = verticlePipes.find(vp => {
                        if (vp.pipe === nextVertex.pipes[0]) {
                            let pipe = pipesArray.find(p => p.id === nextVertex.pipes[0]);
                            if (pipe) {
                                let v0 = verticesArray.find(v => v.id === pipe.vertices[0]);
                                let v1 = verticesArray.find(v => v.id === pipe.vertices[1]);

                                if (GeometryUtils.isCloseEnoughtWithTolerance(vp.offset, GeometryUtils.pointPositionOnLineSegment(v0.x, v0.y, v1.x, v1.y, nextVertex.x, nextVertex.y), 0.1)) {
                                    return vp
                                }
                                // if (vp.offset === GeometryUtils.pointPositionOnLineSegment(v0.x, v0.y, v1.x, v1.y, nextVertex.x, nextVertex.y)) {
                                //     return vp;
                                // }
                            }
                        }
                        return 0;
                    })

                    if (vertPipeOnCurrentVertex)
                        currentVerticlePipe = vertPipeOnCurrentVertex;

                    if (vertPipeOnOtherVertex)
                        currentVerticlePipe = vertPipeOnOtherVertex;

                    if (currentVerticlePipe) {
                        let elbowCombo = new FittingComboModel();
                        elbowCombo.fittingName = 'Elbow';
                        elbowCombo.fittingType = 'pipe';
                        elbowCombo.pipe0ID = currentVertex.pipes[0];
                        elbowCombo.pipe0VertexID = currentVertex.id;
                        elbowCombo.pipe0diameter = this.returnPipeDiameter(currentVertex.pipes[0], pipesArray)
                        elbowCombo.pipe1ID = currentVerticlePipe.id;
                        elbowCombo.pipe1VertexID = '';
                        elbowCombo.pipe1diameter = currentVerticlePipe.properties.diameter.length;

                        resultArray.push(elbowCombo);

                        let elbowCombo2 = new FittingComboModel();
                        elbowCombo2.fittingName = 'Elbow';
                        elbowCombo2.fittingType = 'pipe';
                        elbowCombo2.pipe0ID = nextVertex.pipes[0];
                        elbowCombo2.pipe0VertexID = nextVertex.id;
                        elbowCombo2.pipe0diameter = this.returnPipeDiameter(nextVertex.pipes[0], pipesArray)
                        elbowCombo2.pipe1ID = currentVerticlePipe.id;
                        elbowCombo2.pipe1VertexID = '';
                        elbowCombo2.pipe1diameter = currentVerticlePipe.properties.diameter.length;

                        resultArray.push(elbowCombo2);
                        configuredVerticlePipes.push(currentVerticlePipe);

                        continue;
                    }
                }
            }
        }
        // if any verticle pipe with single connection left => insert one elbow or triple
        let sigleVerticlePipes = verticlePipes.filter(vp => !configuredVerticlePipes.includes(vp));
        if (sigleVerticlePipes) {
            sigleVerticlePipes.forEach(vp => {
                if (vp.offset <= 0.035 || vp.offset >= 0.97) { //single verticle with elbow
                    let elbowCombo = new FittingComboModel();
                    elbowCombo.fittingName = 'Elbow';
                    elbowCombo.fittingType = 'pipe';
                    elbowCombo.pipe0ID = vp.pipe;
                    elbowCombo.pipe0VertexID = '';
                    elbowCombo.pipe0diameter = this.returnPipeDiameter(vp.pipe, pipesArray)
                    elbowCombo.pipe1ID = vp.id;
                    elbowCombo.pipe1VertexID = '';
                    elbowCombo.pipe1diameter = vp.properties.diameter.length;

                    resultArray.push(elbowCombo);
                }
                else {//single verticle with triple
                    let tripleCombo = new FittingComboModel();
                    tripleCombo.fittingName = 'Tee';
                    tripleCombo.fittingType = 'pipe';
                    tripleCombo.pipe0ID = vp.pipe;
                    tripleCombo.pipe0VertexID = '';
                    tripleCombo.pipe0diameter = this.returnPipeDiameter(vp.pipe, pipesArray);
                    tripleCombo.pipe1ID = vp.id;
                    tripleCombo.pipe1VertexID = '';
                    tripleCombo.pipe1diameter = vp.properties.diameter.length;

                    resultArray.push(tripleCombo);
                }
            })
        }

        return resultArray;
    }

    returnPipeAltitude = (pipeID, pipes) => {
        if (!pipes)
            return 0;

        let pipe = pipes.find(p => p.id === pipeID);
        if (pipe) {
            return pipe.properties.altitude.length;
        }

        return 0;
    }

    returnPipeDiameter = (pipeID, pipes) => {
        if (!pipes)
            return 0;

        let pipe = pipes.find(p => p.id === pipeID);
        if (pipe) {
            return pipe.properties.diameter.length;
        }

        return 0;
    }

    removeZeroLengthPipe = (pipesArray, verticesArray) => {
        let zeroLengthPipeID;
        let zeroLengthV0ID;
        let zeroLengthV1ID;

        pipesArray.forEach(p => {
            let v0 = verticesArray.find(v => v.id === p.vertices[0]);
            let v1 = verticesArray.find(v => v.id === p.vertices[1]);

            if (GeometryUtils.verticesDistance(v0, v1) === 0) {
                zeroLengthPipeID = p.id;
                zeroLengthV0ID = v0.id;
                zeroLengthV1ID = v1.id;
            }
        });

        if (zeroLengthPipeID) {
            pipesArray.splice(pipesArray.findIndex(p => p.id === zeroLengthPipeID), 1);
            verticesArray.splice(pipesArray.findIndex(v => v.id === zeroLengthV0ID), 1);
            verticesArray.splice(pipesArray.findIndex(v => v.id === zeroLengthV1ID), 1);
        }
    }

    //TODO: ask about fittng second diameter, what to do if fitting has two diameters, how to get product from DB then
    getFittingsProducts = (fittingsCombos: Array<FittingComboModel>, products: Array<IProduct>, dbCategories: Array<ICategory>) => {
        let fiittingsProducts = new Array<FittingProductModel>();

        if (fittingsCombos && fittingsCombos.length) {
            fittingsCombos.forEach(f => {
                let fittingProduct = new FittingProductModel();
                let dbProducts = products.filter(p => p.article.toLowerCase().includes(Translate(f.fittingName).toLowerCase()) && p.diameter === f.pipe0diameter);
                let dbProduct = this.getFittingProduct(dbProducts, dbCategories);
                if (dbProduct) {
                    fittingProduct.article = dbProduct.article;
                    fittingProduct.remoteId = dbProduct.remoteId;
                    fittingProduct.diameter = dbProduct.diameter;
                } else {
                    fittingProduct.article = Translate(f.fittingName);
                    fittingProduct.remoteId = 0;
                    fittingProduct.diameter = f.pipe0diameter;
                }

                fiittingsProducts.push(fittingProduct);
            });
        }

        return fiittingsProducts;
    }

    getFittingProduct = (products: Array<IProduct>, dbCategories: Array<ICategory>) => {
        let dbProduct;

        products.forEach(p => {
            let categoryTypeId = this.getProductCategoryType(p.categoryId, dbCategories);
            if (categoryTypeId === CategoryType.Materials) {
                dbProduct = p;
            }
        });

        return dbProduct;
    }

    getItemsFromPlanner = (items, products, categoryPackId, catalogType, categories?) => {
        let plannerProducts: Array<ProductLiteModel> = new Array<ProductLiteModel>(0);
        for (let item in items) {
            let found = products.find(r => r.remoteId === +items[item].type);
            if (items[item].catalogPack && items[item].catalogPack.includes('package')) {
                let packId = +items[item].catalogPack.substring(0, items[item].catalogPack.indexOf('package'));
                let packets = products.filter(r => r.categoryId === categoryPackId);
                let foundedPack = packets.find(r => r.remoteId === packId);
                if (foundedPack) {
                    if (plannerProducts.findIndex(r => r.productId === packId) === -1)
                        found = foundedPack;
                    else
                        found = null;
                }
            }

            let index = items[item].productCount;

            if (found) {
                let product: ProductLiteModel = new ProductLiteModel();
                product.article = found.article;
                product.productId = found.remoteId;
                product.price = found.price;
                product.unitId = found.unitId;
                product.articleNumber = found.articleNumber;
                product.quantity = 1;
                product.billQuantity = 1;
                product.addedFromPlanner = true;
                product.discount = found.discount;
                product.priceWithoutDiscount = found.price;
                product.index = index ? index : 0;

                if (found.discount > 0) {
                    product.price = found.price - (found.price * found.discount / 100);
                }

                if (catalogType === OfferSteps.GasInstallation) {
                    let foundIndex = plannerProducts.findIndex(r => r.productId === found.remoteId);
                    if (foundIndex === -1) {
                        plannerProducts.push(product);
                    }
                    else {
                        plannerProducts[foundIndex].quantity += 1;
                        plannerProducts[foundIndex].billQuantity += 1;
                    }
                }
                else if (catalogType === OfferSteps.HeatingInstallation) {
                    let foundIndex = plannerProducts.findIndex(r => r.productId === found.remoteId);
                    let prodQuantity = 1;
                    if (HelperFunctions.checkIsThatType(found.categoryId, categories, CategoryType.Radiators)) {
                        let ribLength: number = 10;
                        let ribsCount: number = 0;
                        if (items[item].properties && items[item].properties.width) {
                            ribsCount = parseInt((items[item].properties.width.length / ribLength).toFixed(0));
                            prodQuantity = ribsCount;
                        }
                    }
                    if (foundIndex === -1) {
                        product.quantity = prodQuantity
                        product.billQuantity = 1;
                        plannerProducts.push(product);
                    }
                    else {
                        plannerProducts[foundIndex].quantity += prodQuantity;
                        plannerProducts[foundIndex].billQuantity += 1;
                    }
                }
            }

        };

        return plannerProducts;
    }

    handlePlannerSave = (catalogType, outerHTMl, isSaveAndClose, categoryPackId, isAxonometry, onlyPan) => {
        let planner = JSON.parse(JSON.stringify(localStorage.getItem('react-planner_v0')));
        let offer = { ...this.state.newOffer };
        let currentDate = onlyPan ? offer.updatedOn : HelperFunctions.fomatDateTimeAsString(new Date());

        if (!currentDate)
            currentDate = HelperFunctions.fomatDateTimeAsString(new Date());

        offer.updatedOn = currentDate;
        if (planner) {
            if (catalogType !== OfferSteps.TwoDPlan) {
                this.setState({ isLoading: true });
                this.localCategoryService.getAllCategories().then(
                    (cats: any) => {
                        let categories = cats;
                        this.localProductsService.getAllProducts().then(
                            (res: any) => {
                                let jsonPl = JSON.parse(planner);
                                let layer = 'layer-2';
                                if (catalogType === OfferSteps.HeatingInstallation) {
                                    layer = 'layer-3'
                                }

                                let items = jsonPl.layers[layer].items;
                                let productsNotFromPlanner;
                                let additionalProductsNotFromPlanner;

                                if (catalogType === OfferSteps.GasInstallation) {
                                    if (!offer.gasInstallation.products) {
                                        offer.gasInstallation.products = new Array<ProductLiteModel>(0);
                                    } else {
                                        productsNotFromPlanner = offer.gasInstallation.products.filter(p => p.addedFromPlanner === false);
                                    }

                                    if (!offer.gasInstallation.additionalProducts) {
                                        offer.gasInstallation.additionalProducts = new Array<ProductLiteModel>(0);
                                    } else {
                                        additionalProductsNotFromPlanner = offer.gasInstallation.additionalProducts.filter(p => p.addedFromPlanner === false);
                                    }

                                } else {
                                    if (!offer.heathInstall.products) {
                                        offer.heathInstall.products = new Array<ProductLiteModel>(0);
                                    } else {
                                        productsNotFromPlanner = offer.heathInstall.products.filter(p => p.addedFromPlanner === false);
                                    }

                                    if (!offer.heathInstall.additionalProducts) {
                                        offer.heathInstall.additionalProducts = new Array<ProductLiteModel>(0);
                                    } else {
                                        additionalProductsNotFromPlanner = offer.heathInstall.additionalProducts.filter(p => p.addedFromPlanner === false);
                                    }
                                }

                                if (catalogType === OfferSteps.GasInstallation) {
                                    let products = this.getItemsFromPlanner(items, res, categoryPackId, catalogType, categories);
                                    let productsServices = this.getServicesFromItemsFromPlanner(products, res, cats);

                                    offer.gasInstallation.products = products
                                    offer.gasInstallation.products.push(...productsNotFromPlanner)

                                    offer.gasInstallation.additionalProducts = productsServices;
                                    offer.gasInstallation.additionalProducts.push(...additionalProductsNotFromPlanner);
                                }
                                else {
                                    let products = this.getItemsFromPlanner(items, res, categoryPackId, catalogType, categories);
                                    let productsServices = this.getServicesFromItemsFromPlanner(products, res, cats);

                                    offer.heathInstall.products = products;
                                    offer.heathInstall.products.push(...productsNotFromPlanner);

                                    offer.heathInstall.additionalProducts = productsServices;
                                    offer.heathInstall.additionalProducts.push(...additionalProductsNotFromPlanner);
                                }

                                let pipes = jsonPl.layers[layer].pipes;
                                let holes = jsonPl.layers[layer].holes;
                                let pipeInfo = this.getPipeInfo(pipes, jsonPl.unit, holes);

                                this.addFittings(res, categories, offer);

                                let fittings = this.getFittings(holes);

                                if (catalogType === OfferSteps.HeatingInstallation) {

                                    // Double heat pipes lenght
                                    if (pipeInfo) {
                                        if (pipeInfo.pipes) {
                                            pipeInfo.pipes.forEach(pipe => {
                                                pipe.pipeLength = pipe.pipeLength * 2;
                                            })
                                        }

                                        pipeInfo.lengthSum = pipeInfo.lengthSum * 2;
                                        pipeInfo.lengthSumRound = pipeInfo.lengthSumRound * 2
                                    }

                                    offer.heathInstall.pipeInfo = pipeInfo;
                                    offer.heathInstall.fittings = fittings;
                                }
                                else {
                                    //this.calculatePipes(offer, pipeInfo, res);

                                    if (offer.gasInstallation.fittings) {
                                        let autoFittings = offer.gasInstallation.fittings.autoFittings;

                                        if (autoFittings) {
                                            fittings.autoFittings = autoFittings;
                                        }
                                    }

                                    offer.gasInstallation.pipeInfo = pipeInfo;
                                    offer.gasInstallation.fittings = fittings;
                                }

                                offer.planner = JSON.parse(planner);
                                offer.planner.layers['layer-1'] = this.removeSelectedFromLayer(offer.planner.layers['layer-1']);
                                offer.planner.layers['layer-2'] = this.removeSelectedFromLayer(offer.planner.layers['layer-2']);
                                offer.planner.layers['layer-3'] = this.removeSelectedFromLayer(offer.planner.layers['layer-3']);

                                let content = this.generatePDFService.getSvgContent(outerHTMl, offer, isAxonometry, catalogType);
                                this.generatePDFService.createPDFDocument(offer, content).then(
                                    pdfFile => {
                                        if (!isAxonometry) {
                                            offer.installationPdf = this.createFile(offer.installationPdf, pdfFile, Translate("Installation") + " - " + offer.offerNumber);
                                            offer.installationPdf.updatedOn = currentDate;
                                        }
                                        else {
                                            if (catalogType === OfferSteps.GasInstallation) {
                                                offer.gasInstallation.axonometryPdf =
                                                    this.createFile(offer.gasInstallation.axonometryPdf, pdfFile, Translate("AxonometricSchemeG") + " - " + offer.offerNumber)
                                                offer.gasInstallation.axonometryPdf.updatedOn = currentDate;
                                            }
                                            else {
                                                offer.heathInstall.axonometryPdf =
                                                    this.createFile(offer.heathInstall.axonometryPdf, pdfFile, Translate("AxonometricSchemeH") + " - " + offer.offerNumber)
                                                offer.heathInstall.axonometryPdf.updatedOn = currentDate;
                                            }
                                        }

                                        this.setStateAfterPlannerSave(isSaveAndClose, offer);
                                    }
                                ).catch(
                                    error => {
                                        this.snackbar.show({ severity: 'error', summary: error });
                                        this.setStateAfterPlannerSave(isSaveAndClose, offer);
                                    }
                                );

                            }
                        )
                            .catch(err => {
                                console.log(err)
                                this.setState({ isLoading: false });
                            });
                    }).catch(error => {
                        this.setState({ isLoading: false });
                        this.snackbar.show({ severity: 'error', summary: error })
                    })
            }
            else {
                //offer.imgSrc = imgSrc;
                offer.planner = JSON.parse(planner);
                offer.planner.layers['layer-1'] = this.removeSelectedFromLayer(offer.planner.layers['layer-1']);
                offer.planner.layers['layer-2'] = this.removeSelectedFromLayer(offer.planner.layers['layer-2']);
                offer.planner.layers['layer-3'] = this.removeSelectedFromLayer(offer.planner.layers['layer-3']);
                this.setStateAfterPlannerSave(isSaveAndClose, offer);
            }
        }
    }

    setStateAfterPlannerSave = (isSaveAndClose, offer) => {
        if (isSaveAndClose)
            this.setState({ newOffer: offer, isLoading: false, copiedLayer: false }, () => this.handleSave(false, false));
        else
            this.setState({ newOffer: offer, isLoading: false, copiedLayer: false });
    }

    handleSaveFromPlanner = (isSaved) => {
        if (isSaved)
            this.handleSave(false, false);
    }

    handleAddressDropDownChange = (e) => {
        let offer = { ...this.state.newOffer };
        if (e === 0) {
            if (!offer.clientData)
                offer.clientData = new ClientDataModel();
            offer.clientData.locationId = 0;
            offer.clientData.address = '';
            offer.clientData.disctrict = '';
            offer.clientData.municipality = '';
            offer.clientData.town = '';
        } else {
            let locations = [...this.state.allLocations];
            let found = locations.find(r => r.id === e);
            if (found) {
                offer.clientData.locationId = found.id;
                offer.clientData.address = found.address;
                offer.clientData.disctrict = found.disctrict;
                offer.clientData.municipality = found.municipality;
                offer.clientData.town = found.town;
                offer.clientData.latitude = found.latitude;
                offer.clientData.longitude = found.longitude;
            }
        }
        this.setState({ selectedAddress: e, newOffer: offer })
    }

    handlePipeInstallChange = (e) => {
        let offer = { ...this.state.newOffer };
        let gasInstall = offer.gasInstallation;
        gasInstall.pipeInstall = e;
        offer.gasInstallation = gasInstall;
        this.setState({ newOffer: offer })
    }

    handleHeathPipeInstallChange = (e) => {
        let offer = { ...this.state.newOffer };
        let heathInstall = offer.heathInstall;
        heathInstall.pipeInstall = e;
        offer.heathInstall = heathInstall;
        this.setState({ newOffer: offer })
    }

    createLiteProductModel = (selectedProduct) => {
        let lite = new ProductLiteModel();
        lite.id = 0;
        lite.article = selectedProduct.article;
        lite.articleNumber = selectedProduct.articleNumber;
        lite.price = selectedProduct.price;
        lite.productId = selectedProduct.productId;
        lite.unitId = selectedProduct.unitId;
        lite.quantity = 1;
        lite.billQuantity = 1;
        lite.priceWithoutDiscount = selectedProduct.price;
        lite.discount = selectedProduct.discount;

        if (selectedProduct.discount > 0) {
            lite.price = selectedProduct.price - (selectedProduct.price * selectedProduct.discount / 100);
        }

        return lite;
    }

    onChangeQuantity = (product: any, value: any, type: string, isAdditional: boolean) => {
        let offer = { ...this.state.newOffer };

        if (value >= 0) {
            if (isAdditional) {
                let index = offer[type].additionalProducts.findIndex(r => r.productId === product.productId);
                if (index !== -1) {
                    offer[type].additionalProducts[index].quantity = value;
                    offer[type].additionalProducts[index].billQuantity = value;
                }
            } else {
                let index = offer[type].products.findIndex(r => r.productId === product.productId);
                if (index !== -1) {
                    offer[type].products[index].quantity = value;
                    offer[type].products[index].billQuantity = value;
                }
            }

            this.setState({ newOffer: offer })
        }
    }

    onChangePrice = (product: ProductLiteModel, value: any) => {
        let offer = { ...this.state.newOffer };
        if (+value >= 0) {
            let index = offer.heathInstall.additionalProducts.findIndex(r => r.productId === product.productId);
            if (index !== -1) {
                offer.heathInstall.additionalProducts[index].price = +value;
            }

            this.setState({ newOffer: offer });
        }
    }

    handleAddButton = (gasInstall: boolean, isAdditionalProduct: boolean) => {
        const { currentSelection, searchedProducts } = this.state;

        let selectedProduct = searchedProducts.find((product) => product.productId === (currentSelection as DropdownModel).value);

        if (selectedProduct) {
            let offer = { ...this.state.newOffer };
            if (gasInstall) {
                if (isAdditionalProduct) {
                    if (!offer.gasInstallation.additionalProducts)
                        offer.gasInstallation.additionalProducts = new Array<ProductLiteModel>(0);

                    if (offer.gasInstallation.additionalProducts.findIndex(r => r.productId === selectedProduct?.productId) === -1) {
                        let lite = this.createLiteProductModel(selectedProduct);
                        lite.addedFromPlanner = false;

                        if (offer.gasInstallation.pipeInfo && lite.unitId === Units.UnitLinearMeter) {
                            let length = convert(offer.gasInstallation.pipeInfo.lengthSumRound).from('cm').to('m');
                            let quantity = length / 5;
                            lite.quantity = quantity;
                        }
                        offer.gasInstallation.additionalProducts.push(lite);
                    } else {
                        this.snackbar.show({ severity: 'error', summary: Translate('Product is already added') })
                    }
                } else {
                    if (!offer.gasInstallation.products)
                        offer.gasInstallation.products = new Array<ProductLiteModel>(0);

                    if (offer.gasInstallation.products.findIndex(r => r.productId === selectedProduct?.productId) === -1) {
                        let lite = this.createLiteProductModel(selectedProduct);
                        lite.addedFromPlanner = false;
                        offer.gasInstallation.products.push(lite);
                    } else {
                        this.snackbar.show({ severity: 'error', summary: Translate('Product is already added') })
                    }
                }

            } else {
                if (isAdditionalProduct) {
                    if (!offer.heathInstall.additionalProducts)
                        offer.heathInstall.additionalProducts = new Array<ProductLiteModel>(0);

                    if (offer.heathInstall.additionalProducts.findIndex(r => r.productId === selectedProduct?.productId) === -1) {
                        let lite = this.createLiteProductModel(selectedProduct);
                        lite.addedFromPlanner = false;
                        if (offer.heathInstall.pipeInfo && lite.unitId === Units.UnitLinearMeter) {
                            let length = convert(offer.heathInstall.pipeInfo.lengthSumRound).from('cm').to('m');
                            let quantity = length / 5;
                            lite.quantity = quantity;
                            lite.billQuantity = quantity;
                        }
                        offer.heathInstall.additionalProducts.push(lite);
                    } else {
                        this.snackbar.show({ severity: 'error', summary: Translate('Product is already added') })
                    }
                } else {
                    if (!offer.heathInstall.products)
                        offer.heathInstall.products = new Array<ProductLiteModel>(0);

                    if (offer.heathInstall.products.findIndex(r => r.productId === selectedProduct?.productId) === -1) {
                        let lite = this.createLiteProductModel(selectedProduct);
                        lite.addedFromPlanner = false;
                        offer.heathInstall.products.push(lite);
                    } else {
                        this.snackbar.show({ severity: 'error', summary: Translate('Product is already added') })
                    }
                }
            }

            this.setState({
                currentSelection: null,
                searchedProducts: [],
                searchTerm: '',
                searchedProductsDropDown: [],
                newOffer: offer
            });
        }
    }

    handleExistingClientSelected = (selectedClient: ClientSearchModel) => {
        let offer = { ...this.state.newOffer };
        offer.clientData = new ClientDataModel();

        offer.clientData.clientId = selectedClient.client.id;
        offer.clientData.name = selectedClient.client.name;
        offer.clientData.email = selectedClient.client.email;
        offer.clientData.phone = selectedClient.client.phone;

        if (selectedClient.locations && selectedClient.locations.length > 0) {
            let addresses: Array<ClientLocationModel> = selectedClient.locations;
            let addressesDrowp: Array<DropdownModel> = new Array<DropdownModel>();
            addressesDrowp.push({ value: 0, label: Translate('New') });
            addresses.forEach(r => {
                addressesDrowp.push({ label: r.address, value: r.id })
            });

            this.setState({
                isLoading: false,
                clientAddresses: addressesDrowp,
                allLocations: addresses,
                newOffer: offer,
                selectedClientId: selectedClient.client.id,
                selectedAddress: 0
            }, () => addresses && addresses.length === 1 ? this.handleAddressDropDownChange(addresses[0].id) : null);
        } else {
            let addressesDrowp: Array<DropdownModel> = new Array<DropdownModel>();
            addressesDrowp.push({ value: 0, label: Translate('New') });
            this.setState({
                selectedClient,
                clientAddresses: addressesDrowp,
                newOffer: offer,
                selectedClientId: selectedClient.client.id,
                selectedAddress: 0
            });
        }
    }

    onNewClient = () => {
        let offer = { ...this.state.newOffer };
        offer.clientData = new ClientDataModel();

        this.setState({
            selectedClient: new ClientSearchModel(),
            selectedAddress: 0,
            selectedClientId: 0,
            newOffer: offer,
        });
    }

    handleGasInstallTabChange = (activeTab: number) => {
        const { newOffer } = this.state;

        newOffer.gasInstallation.activeTab = activeTab;

        this.setState({
            newOffer
        });
    }

    handleHeatInstallTabChange = (activeTab: number) => {
        const { newOffer } = this.state;

        newOffer.heathInstall.activeTab = activeTab;

        this.setState({
            newOffer
        });
    }

    handleSendEmailClick = () => {
        const { newOffer } = this.state;

        if (!newOffer.clientData.email) {
            this.snackbar.show({ severity: 'error', summary: Translate('Please add email to client data.') });
            return;
        }

        this.setState({
            isVisibleSendEmailConfirmDialog: true,
        });
    }

    sendEmail = () => {

        this.setState({
            isVisibleSendEmailConfirmDialog: false,
            isLoading: true
        });

        const { newOffer } = this.state;
        let pdfFile = newOffer.offerPdf;

        let lang = localStorage.getItem('lang');
        if (!lang) {
            lang = 'bg';
        }
        let langId: any = HelperFunctions.getLangId(lang);

        if (pdfFile) {
            let newMail = new EmailDataModel();
            newMail.to = newOffer.clientData.email;
            newMail.toName = newOffer.clientData.name;
            newMail.from = this.authService.getLoginName();
            newMail.replyTo = this.authService.getLoginName();
            newMail.offerNumber = newOffer.offerNumber;
            newMail.attachments = new Array<FileModel>();
            newMail.attachments.push(pdfFile);

            this.emailService.sendOfferToClient(langId, newMail).then(
                (res: any) => {
                    this.setState({ isLoading: false });
                    this.snackbar.show({ severity: 'success', summary: Translate('Offer send successfully') })
                })
                .catch(error => {
                    this.setState({ isLoading: false });
                    this.snackbar.show({ severity: 'error', summary: Translate('Email sending failed') })
                });
        } else {
            this.setState({ isLoading: false });
            this.snackbar.show({ severity: 'error', summary: Translate('Problem with offer pdf file') })
        }
    }

    getStepContent = (step: number) => {
        const { newOffer, selectedClientId, selectedAddress, clientAddresses, searchedProductsDropDown, currentSelection, validations, readOnly } = this.state;

        switch (step) {
            case OfferSteps.ClientData:
                return (
                    <div>
                        <ClientDataComponent
                            clientData={newOffer.clientData}
                            onChangeClient={this.handleChangeClient}
                            handleHeatSwitchChange={this.handleHeatSwitchChange}
                            handleWorkSwitchChange={this.handleWorkSwitchChange}
                            handleEquipmentOnlySwitchChange={this.handleEquipmentOnlySwitchChange}
                            heatInstall={newOffer.heathInstallCheck}
                            workAndMaterials={newOffer.workAndMaterials}
                            equipmentOnly={newOffer.equipmentOnly}
                            selectedClientId={selectedClientId}
                            selectedAddress={selectedAddress}
                            clientAddresses={clientAddresses}
                            handleDwopdownAddressChange={this.handleAddressDropDownChange}
                            validations={validations}
                            handleExistingClientSelected={this.handleExistingClientSelected}
                            handleNewClient={this.onNewClient}
                            handleEditClient={this.handleEditClient}
                            readOnly={readOnly}
                            getLocation={this.getLocation}
                            removeLocation={this.removeLocation}
                        />
                    </div>);
            case OfferSteps.TwoDPlan:
                return (
                    <div>
                        <PlannerHouseComponent
                            activeStepNumber={step + 1}
                            activeStep={HelperFunctions.getEnumLabel(step, OfferSteps, true)}
                            twoDimPlan={newOffer.twoDimPlan}
                            handleChange={this.handleTwoDimChange}
                            saveClick={this.handlePlannerSave}
                            planner={newOffer.planner}
                            offer={newOffer}
                            copiedLayer={this.state.copiedLayer}
                            readOnly={readOnly} />
                    </div>);
            case OfferSteps.GasInstallation:
                return <div>
                    <GasInstallation
                        gasInstall={newOffer.gasInstallation}
                        handlePipeInstallChange={this.handlePipeInstallChange}
                        activeStepNumber={step + 1}
                        activeStep={HelperFunctions.getEnumLabel(step, OfferSteps, true)}
                        saveClick={this.handlePlannerSave}
                        gasInstallWorkChange={this.handleGasInstallWorkChange}
                        planner={newOffer.planner}
                        searchedProductsDropDown={searchedProductsDropDown}
                        currentSelection={currentSelection}
                        handleAutocompleteSelection={this.handleAutocompleteSelection}
                        handleAutocompleteKeyUp={this.handleAutocompleteKeyUp}
                        handleAddButton={this.handleAddButton}
                        handleDeleteWorkGasClick={this.handleDeleteGasProductClick}
                        onChangeQuantity={this.onChangeQuantity}
                        fullSave={this.handleSaveFromPlanner}
                        offer={newOffer}
                        copiedLayer={this.state.copiedLayer}
                        calculatePipes={this.handleCalculatePipe}
                        addFittings={this.handleAddFittingsButton}
                        changeTab={this.handleGasInstallTabChange}
                        readOnly={readOnly}
                        equipmentOnly={newOffer.equipmentOnly}
                        resetSearechedProducts={this.resetSearechedProducts}
                    />
                </div>;
            case OfferSteps.HeatingInstallation:
                return <div>
                    <HeathInstallationComponent
                        heathInstall={newOffer.heathInstall}
                        handlePipeInstallChange={this.handleHeathPipeInstallChange}
                        activeStepNumber={step + 1}
                        planner={newOffer.planner}
                        activeStep={HelperFunctions.getEnumLabel(step, OfferSteps, true)}
                        saveClick={this.handlePlannerSave}
                        heathInstallWorkChange={this.handleHeathInstallWorkChange}
                        searchedProductsDropDown={searchedProductsDropDown}
                        currentSelection={currentSelection}
                        handleAutocompleteSelection={this.handleAutocompleteSelection}
                        handleAutocompleteKeyUp={this.handleAutocompleteKeyUp}
                        handleAddButton={this.handleAddButton}
                        handleDeleteWorkHeathClick={this.handleDeleteHeathProductClick}
                        onChangeQuantity={this.onChangeQuantity}
                        fullSave={this.handleSaveFromPlanner}
                        offer={newOffer}
                        copiedLayer={this.state.copiedLayer}
                        changeTab={this.handleHeatInstallTabChange}
                        readOnly={readOnly}
                        resetSearechedProducts={this.resetSearechedProducts}
                        onChangePrice={this.onChangePrice}
                    />
                </div>
            case OfferSteps.GenerateOffer:
                return (
                    <>
                        <GenerateOfferComponent
                            offerData={newOffer}
                            onOfferChange={this.handleOfferChange}
                            showGrowl={this.showGenerateGrowl}
                            copiedLayer={this.state.copiedLayer}
                            activeStepNumber={step + 1}
                            planner={newOffer.planner}
                            activeStep={HelperFunctions.getEnumLabel(step, OfferSteps, true)}
                            fullSave={this.handleSaveFromPlanner}
                            saveClick={this.handlePlannerSave}
                            readOnly={readOnly}
                            getLocation={this.getLocation}
                            removeLocation={this.removeLocation}
                            sendEmailClick={this.handleSendEmailClick}
                            changeStatus={this.changeOfferStatus}
                        />
                    </>
                );
            default:
                return 'Unknown step';
        }
    }

    showGenerateGrowl = (type) => {
        this.snackbar.show({ severity: 'warning', summary: type === 'gasInstallSvg' ? Translate('NoGasInstallSchema') : Translate('NoHeathInstallSchema') });
    }

    handleDeleteGasProductClick = (id, isAdditional) => {
        let offer = { ...this.state.newOffer };

        if (isAdditional) {
            let foundIndex = offer.gasInstallation.additionalProducts.findIndex(r => r.productId === id);

            if (foundIndex !== -1) {
                offer.gasInstallation.additionalProducts.splice(foundIndex, 1);
            }
        } else {
            let foundIndex = offer.gasInstallation.products.findIndex(r => r.productId === id);

            if (foundIndex !== -1) {
                offer.gasInstallation.products.splice(foundIndex, 1);
            }
        }

        this.setState({ newOffer: offer })
    }

    handleDeleteHeathProductClick = (id, isAdditional) => {
        let offer = { ...this.state.newOffer };

        if (isAdditional) {
            let foundIndex = offer.heathInstall.additionalProducts.findIndex(r => r.productId === id);
            if (foundIndex !== -1) {
                offer.heathInstall.additionalProducts.splice(foundIndex, 1);
            }
        } else {
            let foundIndex = offer.heathInstall.products.findIndex(r => r.productId === id);
            if (foundIndex !== -1) {
                offer.heathInstall.products.splice(foundIndex, 1);
            }
        }

        this.setState({ newOffer: offer })
    }

    handleAutocompleteSelection = (e, value) => {
        this.setState({
            currentSelection: value
        });
    }

    handleAutocompleteKeyUp = (value, isGasInstall, isAdditionalProducts) => {
        this.setState({
            searchTerm: value
        }, () => this.searchProducts(isGasInstall, isAdditionalProducts))
    }

    resetSearechedProducts = () => {
        this.setState({
            searchedProducts: [],
            searchedProductsDropDown: [],
            currentSelection: null
        });
    }

    searchProducts = (isGasInstall, isAdditionalProducts) => {
        const { searchTerm } = this.state;

        this.setState({
            searchedProducts: [],
            searchedProductsDropDown: [],
            currentSelection: null
        });

        if (searchTerm && searchTerm.length > 2) {
            this.setState({
                isLoading: true,
            });

            let filter = new ProductRelationFilterModel();
            filter.searchTerm = searchTerm;
            filter.isGasInstall = isGasInstall;
            filter.categoryTypes = new Array<CategoryType>(0);

            if (isAdditionalProducts) {
                filter.categoryTypes.push(CategoryType.Services);
            } else {
                filter.categoryTypes.push(CategoryType.Equipment, CategoryType.Materials, CategoryType.Kits);
            }

            if (searchTerm && searchTerm.length < 3) {
                return;
            }

            this.localProductsService.getFilteredProducts(filter).then(
                (data: any) => {
                    let productsDropdown = new Array<DropdownModel>(0);
                    data.forEach(r => productsDropdown.push({ label: r.articleNumber + ' | ' + r.article, value: r.productId }));
                    this.setState({
                        isLoading: false,
                        searchedProducts: data,
                        searchedProductsDropDown: productsDropdown
                    });
                })
                .catch(
                    error => {
                        this.setState({
                            isLoading: false,
                        });
                        this.snackbar.show({ severity: 'error', summary: error });
                    }
                )
        }

    }

    isValid = () => {
        let offer = { ...this.state.newOffer };
        let validations = new Array<string>(0);
        let error = "";

        if (offer.activeStep === OfferSteps.ClientData) {
            if (!offer.clientData.name) {
                validations.push("name");
                error += Translate("Please enter cleint name.") + " ";
            }

            if (!offer.clientData.address) {
                validations.push("address");
                error += Translate("Please enter cleint address.") + " ";
            }

            if (!offer.clientData.town) {
                validations.push("town");
                error += Translate("Please enter cleint town.") + " ";
            }

            if (offer.clientData.name && offer.clientData.name.trim().split(' ').length < 2) {
                validations.push("name");
                error += Translate("Please enter two client names.") + " ";
            }
        }

        if (offer.activeStep === OfferSteps.TwoDPlan) {
            if (!offer.planner || (offer.planner && Object.values(offer.planner.layers["layer-1"].lines).length < 1)) {
                error += Translate("Please add at least one item to 2D schema.") + " ";
            }
        }

        if (offer.activeStep === OfferSteps.GasInstallation) {
            if (!offer.equipmentOnly) {
                if (offer.gasInstallation.products?.length === 0) {
                    error += Translate("Please add at least one item to Gas installation schema.") + " ";
                }
            }
        }

        // if (offer.activeStep === OfferSteps.HeatingInstallation) {
        //     if (!offer.equipmentOnly) {
        //         if (offer.heathInstall.products?.length === 0) {
        //             error += Translate("Please add at least one item to Heat installation schema.") + " ";
        //         }
        //     }
        // }

        this.setState({
            validations: validations
        });

        if (error !== "") {
            this.snackbar.show({ severity: 'error', summary: error });
            return false;
        }

        return true;
    }

    showSaveAndReportError = (error) => {
        this.setState({
            isLoading: false,
            spinnerText: '',
        });
        this.snackbar.show({ severity: "error", summary: Translate(error) });
    }

    saveAndReportOffer = () => {
        if (!this.isValid()) {
            this.setState({
                isLoading: false
            });
            return;
        }

        this.setState({
            isLoading: true,
            spinnerText: Translate('Synchronization please wait')
        });

        let offer = { ...this.state.newOffer };

        let totalAmount = 0;
        if (offer.gasInstallation && offer.gasInstallation.products) {
            totalAmount += HelperFunctions.calculateProductsPrice(offer.gasInstallation.products);
        }

        if (offer.heathInstall && offer.heathInstall.products) {
            totalAmount += HelperFunctions.calculateProductsPrice(offer.heathInstall.products);
        }

        if (offer.gasInstallation && offer.gasInstallation.additionalProducts) {
            totalAmount += HelperFunctions.calculateProductsPrice(offer.gasInstallation.additionalProducts);
        }

        if (offer.heathInstall && offer.heathInstall.additionalProducts) {
            totalAmount += HelperFunctions.calculateProductsPrice(offer.heathInstall.additionalProducts);
        }
        offer.price = totalAmount;

        let traderName = this.authService.getUserName();
        let traderPhone = this.authService.getUserPhone();
        if (offer.trader && offer.trader.userId) {
            traderName = offer.trader.name;
            traderPhone = offer.trader.phone;
        }

        let content = this.generatePDFService.getOfferContent(offer, totalAmount, traderName, traderPhone);

        this.generatePDFService.createPDFDocument(offer, content).then((pdf: any) => {

            offer.offerPdf = this.createFile(offer.offerPdf, pdf, (Translate('Offer') + " - " + offer.offerNumber));

            this.generateXlxsService.generateBillOfQuantities(offer).then(
                (billOfQuantitiesResult: any) => {
                    if (billOfQuantitiesResult.devicesAndMaterials) {
                        offer.billOfQuantitiesExcel = this.createFile(offer.billOfQuantitiesExcel, billOfQuantitiesResult.devicesAndMaterials, Translate('Bill of quantities') + ' - ' + offer.offerNumber);
                    } else {
                        offer.billOfQuantitiesExcel = new FileModel();
                    }

                    if (billOfQuantitiesResult.labor) {
                        offer.billOfQuantitiesLaborExcel = this.createFile(offer.billOfQuantitiesLaborExcel, billOfQuantitiesResult.labor, Translate('Bill of quantities labor') + ' - ' + offer.offerNumber);
                    } else {
                        offer.billOfQuantitiesLaborExcel = new FileModel();
                    }

                    if (!offer.id) {
                        this.localOffersService.createOffer(offer)
                            .then(
                                (newOfferId: any) => {
                                    this.localOffersService.getOfferForSynchronization(+newOfferId).then(
                                        (syncOffer: any) => {
                                            if (syncOffer) {
                                                this.synchronizationService.reportOffer(syncOffer).then(
                                                    (reportedOffer) => {
                                                        if (reportedOffer) {
                                                            this.localOffersService.updateOfferAfterSynchronization(reportedOffer).then(
                                                                () => {
                                                                    this.setState({
                                                                        isLoading: false
                                                                    });

                                                                    if (!syncOffer.id) {
                                                                        this.localOffersService.incrementServerOffersCount();
                                                                    }

                                                                    this.props.history.push('/offers/');

                                                                }).catch(error => {
                                                                    this.showSaveAndReportError(error);
                                                                })
                                                        } else {
                                                            this.props.history.push('/offers/');
                                                        }
                                                    }).catch(error => {
                                                        this.showSaveAndReportError(error);
                                                    })
                                            }
                                        }).catch(error => {
                                            this.showSaveAndReportError(error);
                                        })
                                }).catch(error => {
                                    this.showSaveAndReportError(error);
                                });
                    } else {
                        this.localOffersService.updateOffer(offer).then(
                            () => {
                                this.localOffersService.getOfferForSynchronization(offer.id).then(
                                    (syncOffer: any) => {
                                        if (syncOffer) {
                                            this.synchronizationService.reportOffer(syncOffer).then(
                                                (reportedOffer) => {
                                                    if (reportedOffer) {
                                                        this.localOffersService.updateOfferAfterSynchronization(reportedOffer).then(
                                                            () => {
                                                                this.setState({
                                                                    isLoading: false,
                                                                    spinnerText: ''
                                                                });

                                                                if (!syncOffer.id) {
                                                                    this.localOffersService.incrementServerOffersCount();
                                                                }

                                                                this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully Server') });

                                                                this.initData();
                                                            }).catch(error => {
                                                                this.showSaveAndReportError(error);
                                                            })
                                                    } else {
                                                        this.setState({
                                                            isLoading: false,
                                                            spinnerText: ''
                                                        });
                                                    }
                                                }).catch(error => {
                                                    this.showSaveAndReportError(error);
                                                })
                                        }
                                    }).catch(error => {
                                        this.showSaveAndReportError(error);
                                    });

                            }).catch(error => {
                                this.showSaveAndReportError(error);
                            });
                    }
                }
            )
        });
    }

    handleSave = (isSaveAndClose, isAfterRecalculation) => {
        if (!this.isValid()) {
            return;
        }

        this.setState({
            isLoading: true
        });

        let offer = { ...this.state.newOffer };
        let totalAmount = 0;
        if (offer.gasInstallation && offer.gasInstallation.products) {
            totalAmount += HelperFunctions.calculateProductsPrice(offer.gasInstallation.products);
        }

        if (offer.heathInstall && offer.heathInstall.products) {
            totalAmount += HelperFunctions.calculateProductsPrice(offer.heathInstall.products);
        }

        if (offer.gasInstallation && offer.gasInstallation.additionalProducts) {
            totalAmount += HelperFunctions.calculateProductsPrice(offer.gasInstallation.additionalProducts);
        }

        if (offer.heathInstall && offer.heathInstall.additionalProducts) {
            totalAmount += HelperFunctions.calculateProductsPrice(offer.heathInstall.additionalProducts);
        }
        offer.price = totalAmount;

        let traderName = this.authService.getUserName();
        let traderPhone = this.authService.getUserPhone();
        if (offer.trader && offer.trader.userId) {
            traderName = offer.trader.name;
            traderPhone = offer.trader.phone;
        }

        let content = this.generatePDFService.getOfferContent(offer, totalAmount, traderName, traderPhone);

        this.generatePDFService.createPDFDocument(offer, content).then((pdf: any) => {

            offer.offerPdf = this.createFile(offer.offerPdf, pdf, (Translate('Offer') + " - " + offer.offerNumber));

            this.generateXlxsService.generateBillOfQuantities(offer).then(
                (billOfQuantitiesResult: any) => {

                    if (billOfQuantitiesResult.devicesAndMaterials) {
                        offer.billOfQuantitiesExcel = this.createFile(offer.billOfQuantitiesExcel, billOfQuantitiesResult.devicesAndMaterials, Translate('Bill of quantities') + ' - ' + offer.offerNumber);
                    } else {
                        offer.billOfQuantitiesExcel = new FileModel();
                    }

                    if (billOfQuantitiesResult.labor) {
                        offer.billOfQuantitiesLaborExcel = this.createFile(offer.billOfQuantitiesLaborExcel, billOfQuantitiesResult.labor, Translate('Bill of quantities labor') + ' - ' + offer.offerNumber);
                    } else {
                        offer.billOfQuantitiesLaborExcel = new FileModel();
                    }

                    if (!offer.id) {
                        this.localOffersService.createOffer(offer)
                            .then(
                                (newOfferId: any) => {
                                    offer.id = +newOfferId;

                                    this.setState({
                                        isLoading: false,
                                        newOffer: offer
                                    });

                                    if (isSaveAndClose) {
                                        this.props.history.push('/offers/');
                                    } else {
                                        this.props.history.push('/offers/' + newOfferId);
                                        this.initData();

                                        if (isAfterRecalculation) {
                                            this.snackbar.show({ severity: 'success', summary: Translate('Offer recalculation succesfull') });
                                        } else {
                                            this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully Local') });
                                        }

                                    }
                                })
                            .catch(error => {
                                this.setState({
                                    isLoading: false
                                });
                                this.snackbar.show({ severity: "error", summary: Translate(error) });
                            });
                    } else {
                        this.localOffersService.updateOffer(offer).then(
                            () => {
                                this.setState({
                                    isLoading: false,
                                });

                                if (isAfterRecalculation) {
                                    this.snackbar.show({ severity: 'success', summary: Translate('Offer recalculation succesfull') });
                                } else {
                                    this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully Local') });
                                }


                                if (isSaveAndClose) {
                                    this.props.history.push('/offers/');
                                } else {
                                    this.props.history.push('/offers/' + offer.id);
                                    this.initData();
                                }
                            })
                            .catch(error => {
                                this.setState({
                                    isLoading: false
                                });
                                this.snackbar.show({ severity: "error", summary: Translate(error) });
                            })
                    }
                }
            )
        });

    }

    handleSendBtnClick = (isFinish: boolean) => {
        if (!navigator.onLine) {
            this.snackbar.show({ severity: "error", summary: Translate('Report offer no network connection') });
            return;
        }

        if (isFinish) {
            let offer = { ...this.state.newOffer };

            if (offer.offerStatusId === OfferStatus.NewOffer) {
                offer.offerStatusId = OfferStatus.NewOffer;
            }

            this.setState({
                isLoading: true,
                newOffer: offer,
            }, () => this.saveAndReportOffer());
        } else {
            this.saveAndReportOffer();
        }
    }

    isLastStep = () => {
        return this.state.newOffer.activeStep === OfferSteps.GenerateOffer;
    }

    allStepsCompleted = () => {
        if (this.state.newOffer && this.state.newOffer.completed)
            return this.state.newOffer.completed.length === this.state.steps.length;
        return false;
    }

    handleNext = () => {
        if (!this.isValid()) {
            return;
        }

        this.handleComplete();
        this.setActiveStep(this.getNextStep(this.state.newOffer.activeStep));
    }

    getNextStep = (step) => {
        switch (step) {
            case OfferSteps.ClientData:
                if (this.state.newOffer.equipmentOnly) {
                    return OfferSteps.GasInstallation
                }
                return OfferSteps.TwoDPlan;
            case OfferSteps.TwoDPlan:
                return OfferSteps.GasInstallation;
            case OfferSteps.GasInstallation:
                if (this.state.newOffer.heathInstallCheck) {
                    return OfferSteps.HeatingInstallation;
                }
                return OfferSteps.GenerateOffer;
            case OfferSteps.HeatingInstallation:
                return OfferSteps.GenerateOffer
            default:
                return OfferSteps.ClientData;
        }
    }

    getPreviousStep = (step) => {
        switch (step) {
            case OfferSteps.TwoDPlan:
                return StepperPosition.First;
            case OfferSteps.GasInstallation:
                if (this.state.newOffer.equipmentOnly) {
                    return StepperPosition.First;
                }
                return StepperPosition.Second;
            case OfferSteps.HeatingInstallation:
                // if (this.state.newOffer.equipmentOnly) {
                //     return StepperPosition.Second;
                // }
                return StepperPosition.Third;
            case OfferSteps.GenerateOffer:
                if (this.state.newOffer.heathInstallCheck) {
                    return StepperPosition.Fourth;
                }

                // if (this.state.newOffer.equipmentOnly && !this.state.newOffer.heathInstallCheck) {
                //     return StepperPosition.Second;
                // }

                return StepperPosition.Third;
            default:
                return 0;
        }
    }

    getActiveStep = (step) => {
        switch (step) {
            case OfferSteps.TwoDPlan:
                return StepperPosition.First;
            case OfferSteps.GasInstallation:
                if (this.state.newOffer.equipmentOnly) {
                    return StepperPosition.First;
                }
                return StepperPosition.Second;
            case OfferSteps.HeatingInstallation:
                if (this.state.newOffer.equipmentOnly) {
                    return StepperPosition.Second;
                }
                return StepperPosition.Third;
            case OfferSteps.GenerateOffer:
                if (this.state.newOffer.heathInstallCheck && !this.state.newOffer.equipmentOnly) {
                    return StepperPosition.Fourth;
                }
                if (this.state.newOffer.equipmentOnly && !this.state.newOffer.heathInstallCheck) {
                    return StepperPosition.Second;
                }

                return StepperPosition.Third;
            default:
                return 0;
        }
    }

    handleBack = () => {
        this.setActiveStep(this.getPreviousStep(this.state.newOffer.activeStep));
    }

    handleStep = (step: number) => () => {
        this.setActiveStep(step);
    }

    handleComplete = () => {
        const offer = { ...this.state.newOffer };
        //const newCompleted = { ...this.state.completed };
        if (offer.completed.findIndex(r => r === offer.activeStep) === -1) {
            offer.completed.push(offer.activeStep)
            this.setState({ newOffer: offer });
        }
        //this.handleNext();
    }

    setActiveStep = (step) => {
        const offer = { ...this.state.newOffer };
        offer.activeStep = step;
        this.setState({ newOffer: offer });
    }

    handleRecalculateBtnClick = () => {
        this.setState({
            isLoading: true
        })

        let offer = { ...this.state.newOffer }

        this.localProductsService.getAllProducts().then(
            (dbProducts: any) => {
                if (dbProducts) {
                    if (offer.gasInstallation && offer.gasInstallation.products) {
                        this.updateProductsLite(offer.gasInstallation.products, dbProducts)
                    }

                    if (offer.gasInstallation && offer.gasInstallation.additionalProducts) {
                        this.updateProductsLite(offer.gasInstallation.additionalProducts, dbProducts)
                    }

                    if (offer.heathInstall && offer.heathInstall.products) {
                        this.updateProductsLite(offer.heathInstall.products, dbProducts)
                    }

                    if (offer.heathInstall && offer.heathInstall.additionalProducts) {
                        this.updateProductsLite(offer.heathInstall.additionalProducts, dbProducts)
                    }
                }

                offer.priceChanged = false;

                this.setState({
                    isLoading: false,
                    newOffer: offer
                }, () => this.handleSave(false, true));

            }).catch(error => {
                this.setState({
                    isLoading: false
                });
                console.log(error);
                this.snackbar.show({ severity: "error", summary: Translate('Problem recalculating offer') });
            })
    }

    updateProductsLite(products: Array<ProductLiteModel>, dbProducts: Array<IProduct>) {
        if (products) {
            products.forEach(product => {
                let dbProduct = dbProducts.find(p => p.remoteId === product.productId);

                if (dbProduct) {
                    product.article = dbProduct.article;
                    product.articleNumber = dbProduct.articleNumber;
                    product.unitId = dbProduct.unitId;
                    product.price = dbProduct.price;
                    product.priceWithoutDiscount = dbProduct.price;
                    product.discount = dbProduct.discount;

                    if (dbProduct.discount > 0) {
                        product.price = dbProduct.price - (dbProduct.price * dbProduct.discount / 100);
                    }
                }
            })
        }
    }

    getLocation = () => {
        let locationOptions = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        navigator.geolocation.getCurrentPosition(this.setLocation, this.onErrorGetLocation, locationOptions);
    }

    onErrorGetLocation = () => {
        this.snackbar.show({ severity: "error", summary: Translate('Get location problem occur') });
    }

    setLocation = (location) => {
        if (location) {
            const { newOffer } = this.state;

            newOffer.clientData.latitude = location.coords.latitude;
            newOffer.clientData.longitude = location.coords.longitude;

            this.setState({ newOffer });
        }
    }

    removeLocation = () => {
        const { newOffer } = this.state;

        newOffer.clientData.latitude = '';
        newOffer.clientData.longitude = '';

        this.setState({ newOffer });
    }

    createStatusHistory = (status: number): OfferStatusHistoryModel => {
        let dateStr = HelperFunctions.formatDateAsLongString(new Date());

        let statusHistory = new OfferStatusHistoryModel();
        statusHistory.date = dateStr;
        statusHistory.statusId = status;
        statusHistory.user = this.authService.getUserName();
        statusHistory.userId = this.authService.getUserId();

        return statusHistory;
    }

    changeOfferStatus = (status: number) => {
        const { newOffer } = this.state;

        let statusHistory = this.createStatusHistory(status);
        newOffer.statusHistory.unshift(statusHistory);

        newOffer.offerStatusId = status;
        this.setState({ newOffer, changeStatusDialogIsOpen: false }, () => this.handleSave(false, false));
    }

    toggleChangeStatusDialog = (isVis) => {
        this.setState({
            changeStatusDialogIsOpen: isVis
        });
    }

    render() {
        const { newOffer, steps, isLoading, spinnerText } = this.state;

        return (
            <div className="app-page-content">
                <div style={{ display: "flex" }}>
                    <div style={{ display: 'flex', minWidth: 450, alignItems: 'center' }}>

                        <h1 style={{ margin: 0 }}>{Translate('Offer')} - {newOffer.offerNumber}</h1>
                        <div style={{ margin: "7px 10px 0px 10px", fontSize: "0.8em" }}>
                            {newOffer.id
                                ? <div style={{
                                    ...HelperFunctions.getOfferStatusColor(newOffer.offerStatusId),
                                    cursor: 'pointer', display: 'flex', flexDirection: 'row', padding: 10
                                }}
                                    onClick={() => this.toggleChangeStatusDialog(true)}>
                                    <span style={{ marginRight: "10px" }}>{HelperFunctions.getEnumLabel(newOffer.offerStatusId, OfferStatus, true)}</span>
                                    <FontAwesomeIcon
                                        icon={newOffer.offerStatusId === OfferStatus.NewOffer || newOffer.offerStatusId === OfferStatus.Expired ? faPen : faClock}
                                        color={HelperFunctions.getOfferStatusColor(newOffer.offerStatusId).color} size="1x" style={{ marginLeft: 5 }} />
                                </div>
                                : <div style={{ ...HelperFunctions.getOfferStatusColor(newOffer.offerStatusId), display: 'flex', flexDirection: 'row', padding: 10 }}>
                                    <span style={{ marginRight: "10px" }}>{HelperFunctions.getEnumLabel(newOffer.offerStatusId, OfferStatus, true)}</span>
                                </div>}
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: "100%" }}>
                        <div>
                            <Button variant="contained" color="primary" style={{ marginLeft: "10px", marginTop: "2px", padding: 0, height: 40 }}
                                //disabled={activeStep === 0}
                                onClick={() => this.handleBack()}
                                disabled={newOffer.activeStep === OfferSteps.ClientData}
                            >
                                <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: "20px" }} />
                            </Button>
                            <Button variant="contained" color="primary" style={{ marginLeft: "10px", marginTop: "2px", padding: 0, height: 40 }}
                                onClick={() => this.handleNext()}
                                disabled={newOffer.activeStep === OfferSteps.GenerateOffer}
                            >
                                <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: "20px" }} />
                            </Button>
                        </div>
                        <div>
                            {newOffer.offerStatusId === OfferStatus.NewOffer || newOffer.offerStatusId === OfferStatus.Expired ?
                                <>
                                    <Button variant="contained" color="primary" onClick={() => this.handleSave(false, false)}
                                        style={{ marginLeft: "10px", marginTop: "2px", padding: 0, height: 40 }}>
                                        <FontAwesomeIcon icon={faSave} style={{ fontSize: "20px" }} />
                                    </Button>
                                </>
                                : null}

                            <Button variant="contained" color="secondary" onClick={() => this.handleSendBtnClick(false)}
                                disabled={newOffer.reported || !newOffer.id}
                                style={{ marginLeft: "10px", marginTop: "2px", padding: 0, height: 40 }}>
                                <FontAwesomeIcon icon={faCloudUploadAlt} style={{ fontSize: "20px" }} />
                            </Button>

                            <Button variant="contained" color="primary" style={{ marginLeft: "10px", marginTop: "2px", padding: 0, height: 40 }}
                                disabled={!newOffer.priceChanged}
                                onClick={() => this.handleRecalculateBtnClick()}>
                                <FontAwesomeIcon icon={faCalculator} style={{ fontSize: "20px" }} />
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="step-container">
                    {isLoading ? <Spinner text={spinnerText} /> : null}
                    <Snackbar ref={(el) => this.snackbar = el} />
                    {newOffer
                        ? <>

                            <div className="steps">
                                <Stepper activeStep={this.getActiveStep(newOffer.activeStep)} style={{ backgroundColor: 'unset' }}>
                                    {steps.map((label, index) => (
                                        <Step key={label}>
                                            <StepButton onClick={this.handleStep(label)}
                                                completed={newOffer.completed.indexOf(label) !== -1 || newOffer.offerStatusId > OfferStatus.NewOffer}>
                                                {this.getActiveStep(newOffer.activeStep) === index ?
                                                    <span style={{ fontWeight: 600, fontSize: "1.1em" }}>
                                                        {HelperFunctions.getEnumLabel(label, OfferSteps, true)}
                                                    </span>
                                                    : HelperFunctions.getEnumLabel(label, OfferSteps, true)}
                                            </StepButton>
                                        </Step>
                                    ))}
                                </Stepper>
                            </div>

                            <div className="content-container">
                                <div className="step-content">
                                    {this.getStepContent(newOffer.activeStep)}
                                </div>
                            </div>
                        </>
                        : null}

                </div>
                {this.state.isVisiblePipeCalculationDialog ?
                    <AlertDialog
                        headerTitle={Translate('CalculatePipes')}
                        onClose={() => this.setState({ isVisiblePipeCalculationDialog: false })}
                        isOpen={this.state.isVisiblePipeCalculationDialog}>
                        <div dangerouslySetInnerHTML={{ __html: this.state.pipeCalculationResult }} />
                    </AlertDialog>
                    : null}
                {this.state.isVisibleFittingsCalculationDialog ?
                    <AlertDialog
                        headerTitle={Translate('AddedFittings')}
                        onClose={() => this.setState({ isVisibleFittingsCalculationDialog: false })}
                        isOpen={this.state.isVisibleFittingsCalculationDialog}>
                        <div dangerouslySetInnerHTML={{ __html: this.state.fittingsCalculationResult }} />
                    </AlertDialog>
                    : null}
                {this.state.isVisibleSendEmailConfirmDialog ?
                    <ConfirmDialog
                        headerTitle={Translate("Confirm Dialog")}
                        isVisible={this.state.isVisibleSendEmailConfirmDialog}
                        yesClick={() => { this.sendEmail() }}
                        noClick={() => { this.setState({ isVisibleSendEmailConfirmDialog: false }) }}>
                        {Translate("Do you confirm sending")
                            + " " + newOffer.offerPdf.fileName + ".pdf"
                            + " " + Translate("to client")
                            + " " + newOffer.clientData.name
                            + " " + Translate("with email")
                            + " " + newOffer.clientData.email + "?"}
                    </ConfirmDialog>
                    : null}
                {this.state.changeStatusDialogIsOpen ?
                    <ChangeStatusDialog
                        isOpen={this.state.changeStatusDialogIsOpen}
                        toggle={this.toggleChangeStatusDialog}
                        offer={newOffer}
                        onChangeStatus={this.changeOfferStatus}>
                    </ChangeStatusDialog>
                    : null}
            </div>
        );
    }
}

const mapsStateToProps = state => {
    return {
        isPlannerVisible: state.common.isPlannerVisible
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setPlanner: (isPlannerVisible) => dispatch({ type: actionTypes.PLANNER_VISIBLE, isPlannerVisible: isPlannerVisible })
    }
}

export default connect(mapsStateToProps, mapDispatchToProps)(AddEditOfferComponent);
